import React, { useEffect, useLayoutEffect, useState, useRef, useMemo } from 'react';
import api from '../api';

/* ════════════════════════════════════════════════════════════════
   Telegram Desktop (gece teması) görünümlü istemci — v2
════════════════════════════════════════════════════════════════ */

const BASE = '/api/tg-client';
function getToken() { try { return localStorage.getItem('token') || ''; } catch (e) { return ''; } }
function mediaUrl(path, q = '') { return `${BASE}${path}?token=${encodeURIComponent(getToken())}${q}`; }
const mUrl = (cid, id, q = '') => mediaUrl(`/media/${cid}/${id}`, q);

const T = {
  bg: '#0e1621', side: '#17212b', line: '#0a1119', hover: '#202b36', act: '#2b5278',
  in: '#182533', out: '#2b5278', text: '#f5f5f5', sub: '#7f91a4', dim: '#6c7883',
  accent: '#5288c1', link: '#6ab3f3', input: '#242f3d', menu: '#1f2936', danger: '#ef5b5b',
  online: '#56c26a', metaIn: '#6d7f8f', metaOut: '#7da8d3', badgeMuted: '#3b4754',
};
const NAME_COLORS = ['#ff7a72', '#ffaa5c', '#b38bff', '#5fcf7a', '#4fd1c5', '#6ab3f3', '#f27eb5'];
const AV_GRADS = [['#ff885e', '#ff516a'], ['#ffcd6a', '#ffa85c'], ['#82b1ff', '#665fff'], ['#a0de7e', '#54cb68'], ['#53edd6', '#28c9b7'], ['#72d5fd', '#2a9ef1'], ['#e0a2f3', '#d669ed']];

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Noto+Color+Emoji&display=swap');
.tgc, .tgc * { box-sizing: border-box; }
.tgc { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Color Emoji", "Apple Color Emoji", "Segoe UI Emoji", sans-serif; color: ${T.text}; -webkit-font-smoothing: antialiased; font-size: 14px; }
.tgc ::-webkit-scrollbar { width: 6px; height: 6px; }
.tgc ::-webkit-scrollbar-thumb { background: rgba(255,255,255,.12); border-radius: 3px; }
.tgc ::-webkit-scrollbar-track { background: transparent; }
.tgc input::placeholder, .tgc textarea::placeholder { color: ${T.dim}; }
.tgc-btn { background: none; border: none; color: ${T.dim}; cursor: pointer; padding: 8px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; transition: background .15s, color .15s; flex-shrink: 0; }
.tgc-btn:hover { background: rgba(255,255,255,.07); color: #b6c2cd; }
.tgc-btn:disabled { opacity: .4; cursor: default; }
.tgc-row { transition: background .1s; }
.tgc-row:hover { background: ${T.hover}; }
.tgc-row.act, .tgc-row.act:hover { background: ${T.act}; }
.tgc-mi { display: flex; align-items: center; gap: 14px; width: 100%; padding: 8px 16px; background: none; border: none; color: ${T.text}; font: inherit; font-size: 14px; cursor: pointer; text-align: left; border-radius: 6px; white-space: nowrap; }
.tgc-mi:hover { background: rgba(255,255,255,.07); }
.tgc-mi.danger { color: ${T.danger}; }
.tgc-link { color: ${T.link}; text-decoration: none; cursor: pointer; word-break: break-word; }
.tgc-link:hover { text-decoration: underline; }
.tgc-out .tgc-link { color: #a8d7ff; }
.tgc-spoiler { background: #47596b; color: transparent !important; border-radius: 4px; cursor: pointer; transition: all .2s; }
.tgc-spoiler * { color: transparent !important; }
.tgc-tab { background: none; border: none; color: ${T.dim}; font: inherit; font-size: 13.5px; font-weight: 600; padding: 10px 12px 9px; cursor: pointer; border-bottom: 3px solid transparent; white-space: nowrap; display: inline-flex; align-items: center; gap: 6px; }
.tgc-tab:hover { color: #b6c2cd; }
.tgc-tab.on { color: ${T.link}; border-bottom-color: ${T.link}; }
.tgc-flash { animation: tgcflash 1.8s ease-out; }
@keyframes tgcflash { 0%, 30% { background: rgba(82,136,193,.35); } 100% { background: transparent; } }
@keyframes tgcdot { 0%, 80%, 100% { opacity: .25; } 40% { opacity: 1; } }
.tgc-dots span { animation: tgcdot 1.2s infinite; display: inline-block; }
.tgc-dots span:nth-child(2) { animation-delay: .2s; }
.tgc-dots span:nth-child(3) { animation-delay: .4s; }
@keyframes tgcspin { to { transform: rotate(360deg); } }
.tgc-spin { width: 26px; height: 26px; border: 3px solid rgba(255,255,255,.15); border-top-color: ${T.link}; border-radius: 50%; animation: tgcspin .8s linear infinite; }
.tgc-media-hover { transition: filter .15s; }
.tgc-media-hover:hover { filter: brightness(1.08); }
.tgc pre, .tgc code { font-family: "JetBrains Mono", Consolas, Menlo, monospace; }
.tgc-fade { animation: tgcfade .15s ease-out; }
@keyframes tgcfade { from { opacity: 0; transform: scale(.97); } to { opacity: 1; transform: none; } }
`;

/* ─── helpers ─────────────────────────────────────────────────── */
function fmtTime(u) { return u ? new Date(u * 1000).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' }) : ''; }
function listTime(u) {
  if (!u) return '';
  const d = new Date(u * 1000), n = new Date();
  if (d.toDateString() === n.toDateString()) return fmtTime(u);
  if (n - d < 6 * 86400000) return d.toLocaleDateString('tr-TR', { weekday: 'short' });
  if (d.getFullYear() === n.getFullYear()) return d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit' });
  return d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: '2-digit' });
}
function dateLabel(u) {
  const d = new Date(u * 1000), n = new Date();
  if (d.toDateString() === n.toDateString()) return 'Bugün';
  const y = new Date(n); y.setDate(y.getDate() - 1);
  if (d.toDateString() === y.toDateString()) return 'Dün';
  return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', ...(d.getFullYear() !== n.getFullYear() ? { year: 'numeric' } : {}) });
}
function fmtSize(b) {
  if (!b) return '';
  if (b < 1024) return b + ' B';
  if (b < 1048576) return (b / 1024).toFixed(1) + ' KB';
  if (b < 1073741824) return (b / 1048576).toFixed(1) + ' MB';
  return (b / 1073741824).toFixed(2) + ' GB';
}
function fmtDur(s) {
  s = Math.max(0, Math.round(s || 0));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
  return (h ? h + ':' + String(m).padStart(2, '0') : m) + ':' + String(x).padStart(2, '0');
}
function fmtCount(n) {
  if (!n) return '0';
  if (n >= 1e6) return (n / 1e6).toFixed(1).replace('.0', '') + 'M';
  if (n >= 1e3) return (n / 1e3).toFixed(1).replace('.0', '') + 'K';
  return String(n);
}
function lastSeen(p) {
  if (!p) return null;
  if (p.online) return { t: 'çevrimiçi', on: true };
  if (p.status === 'recently') return { t: 'yakın zamanda görüldü' };
  if (p.status === 'last_week') return { t: 'bu hafta görüldü' };
  if (p.status === 'last_month') return { t: 'bu ay görüldü' };
  if (typeof p.status === 'number') {
    const d = new Date(p.status * 1000), n = new Date();
    if (d.toDateString() === n.toDateString()) return { t: 'son görülme bugün ' + fmtTime(p.status) };
    return { t: 'son görülme ' + d.toLocaleString('tr-TR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) };
  }
  return null;
}
function peerIndex(id) {
  const s = String(id ?? '');
  const digits = s.replace(/^-100/, '').replace(/\D/g, '');
  if (digits) return Number(digits.slice(-9)) % 7;
  let h = 0;
  for (const ch of s) h = (h * 31 + ch.codePointAt(0)) >>> 0;
  return h % 7;
}
const nameColor = id => NAME_COLORS[peerIndex(id)];
function hexA(hex, a) {
  const h = hex.replace('#', '');
  const n = parseInt(h.length === 3 ? h.split('').map(c => c + c).join('') : h, 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
}
function mkRe0(src, flags, fallback) { try { return new RegExp(src, flags); } catch (e) { return fallback; } }
const NON_WORD_RE = mkRe0(String.raw`[^\p{L}\p{N}\s]`, 'gu', /[^\w\s]/g);
const EMOJI_ONLY_RE = mkRe0(String.raw`^(\p{Extended_Pictographic}|\p{Emoji_Presentation}|\u200d|\ufe0f|\s){1,6}$`, 'u', /^$/);
function initials(name) {
  const words = String(name || '?').replace(NON_WORD_RE, ' ').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return [...String(name || '?')][0] || '?';
  return words.slice(0, 2).map(w => [...w][0]).join('').toUpperCase();
}
function mediaLabel(t) {
  return ({ photo: 'Fotoğraf', video: 'Video', round: 'Görüntülü mesaj', voice: 'Sesli mesaj', audio: 'Müzik', file: 'Dosya', sticker: 'Çıkartma', gif: 'GIF', location: 'Konum', poll: 'Anket', contact: 'Kişi', webpage: 'Bağlantı', dice: 'Zar' })[t] || '';
}
const VISUAL = { photo: 1, video: 1, gif: 1 };
const firstName = n => String(n || '').split(' ')[0];

/* ─── icons ───────────────────────────────────────────────────── */
const ICONS = {
  search: <><circle cx="11" cy="11" r="7" /><path d="M20.5 20.5l-4.2-4.2" /></>,
  menu: <><path d="M4 7h16M4 12h16M4 17h16" /></>,
  more: <><circle cx="12" cy="5.5" r="1.4" fill="currentColor" /><circle cx="12" cy="12" r="1.4" fill="currentColor" /><circle cx="12" cy="18.5" r="1.4" fill="currentColor" /></>,
  attach: <path d="M20.5 11.3l-8.3 8.3a5.3 5.3 0 0 1-7.5-7.5l8.6-8.6a3.5 3.5 0 0 1 5 5l-8.6 8.6a1.8 1.8 0 0 1-2.5-2.5l7.9-7.9" />,
  smile: <><circle cx="12" cy="12" r="9.2" /><path d="M8.2 14.2c.9 1.3 2.2 2 3.8 2s2.9-.7 3.8-2" /><circle cx="9" cy="9.6" r="1.1" fill="currentColor" stroke="none" /><circle cx="15" cy="9.6" r="1.1" fill="currentColor" stroke="none" /></>,
  send: <path d="M3.4 20.4l17.45-7.48a1 1 0 0 0 0-1.84L3.4 3.6a.99.99 0 0 0-1.39.91L2 9.12c0 .5.37.93.87.99L17 12 2.87 13.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91z" fill="currentColor" stroke="none" />,
  close: <path d="M6 6l12 12M18 6L6 18" />,
  back: <path d="M15 5l-7 7 7 7" />,
  reply: <><path d="M9.5 6L4 11.5 9.5 17" /><path d="M4.5 11.5H14a6 6 0 0 1 6 6v1" /></>,
  forward: <><path d="M14.5 6L20 11.5 14.5 17" /><path d="M19.5 11.5H10a6 6 0 0 0-6 6v1" /></>,
  pin: <><path d="M9 4h6l-1 5 3 3v2H7v-2l3-3z" /><path d="M12 14v6" /></>,
  copy: <><rect x="8.5" y="8.5" width="11.5" height="11.5" rx="2.5" /><path d="M15.5 8.5V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7.5a2 2 0 0 0 2 2h2.5" /></>,
  trash: <><path d="M4 7h16M10 11v6M14 11v6" /><path d="M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12" /><path d="M9 7V4.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V7" /></>,
  edit: <><path d="M4 20h4L19 9l-4-4L4 16z" /><path d="M13.5 6.5l4 4" /></>,
  check: <path d="M4.5 12.5l5 5 10-11" />,
  select: <><circle cx="12" cy="12" r="9" /><path d="M8 12.3l2.8 2.8L16.3 9.5" /></>,
  eye: <><path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></>,
  archive: <><rect x="3" y="4" width="18" height="5" rx="1.5" /><path d="M5 9v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9M10 13h4" /></>,
  unarchive: <><rect x="3" y="4" width="18" height="5" rx="1.5" /><path d="M5 9v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9M12 18v-6M9.5 14.5L12 12l2.5 2.5" /></>,
  logout: <><path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" /><path d="M10 16l-4-4 4-4M6 12h10" /></>,
  image: <><rect x="3" y="4" width="18" height="16" rx="3" /><circle cx="8.5" cy="9.5" r="1.7" /><path d="M21 15.5l-5-5L5.5 20" /></>,
  file: <><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5" /></>,
  down: <path d="M6 9.5l6 6 6-6" />,
  block: <><circle cx="12" cy="12" r="9" /><path d="M5.6 5.6l12.8 12.8" /></>,
  info: <><circle cx="12" cy="12" r="9" /><path d="M12 11v6M12 7.5v.5" /></>,
  user: <><circle cx="12" cy="8" r="4" /><path d="M4.5 20.5c1.2-3.6 4-5.5 7.5-5.5s6.3 1.9 7.5 5.5" /></>,
  group: <><circle cx="9" cy="8.5" r="3.5" /><path d="M2.5 19.5c.9-3 3.4-4.8 6.5-4.8s5.6 1.8 6.5 4.8" /><path d="M15.5 5.2a3.5 3.5 0 0 1 0 6.6M17.8 14.9c1.8.6 3.1 2.3 3.7 4.6" /></>,
  channel: <><path d="M4 10v4a1 1 0 0 0 1 1h2l6 4V5L7 9H5a1 1 0 0 0-1 1z" /><path d="M17 8.5a5 5 0 0 1 0 7" /></>,
  bot: <><rect x="4" y="8" width="16" height="11" rx="3" /><path d="M12 4v4M9 13h.01M15 13h.01" /></>,
  mute: <><path d="M4 10v4a1 1 0 0 0 1 1h2l6 4V5L7 9H5a1 1 0 0 0-1 1z" /><path d="M17 9.5l4 5M21 9.5l-4 5" /></>,
  phone: <path d="M6.6 3.5h2.6l1.6 4.2-2 1.4a11 11 0 0 0 6.1 6.1l1.4-2 4.2 1.6v2.6a2 2 0 0 1-2.2 2A17 17 0 0 1 4.6 5.7a2 2 0 0 1 2-2.2z" />,
  at: <><circle cx="12" cy="12" r="3.8" /><path d="M15.8 12v1.4a2.6 2.6 0 0 0 5.2 0V12a9 9 0 1 0-3.5 7.1" /></>,
  play: <path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.6-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5z" fill="currentColor" stroke="none" />,
  pause: <><rect x="6.5" y="5" width="4" height="14" rx="1.2" fill="currentColor" stroke="none" /><rect x="13.5" y="5" width="4" height="14" rx="1.2" fill="currentColor" stroke="none" /></>,
  download: <><path d="M12 4v11M7.5 11L12 15.5 16.5 11" /><path d="M5 19.5h14" /></>,
  location: <><path d="M12 21s-6.5-6-6.5-11a6.5 6.5 0 0 1 13 0c0 5-6.5 11-6.5 11z" /><circle cx="12" cy="10" r="2.4" /></>,
  poll: <path d="M6 20V11M12 20V5M18 20v-6" />,
  link: <><path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1.2 1.2" /><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1.2-1.2" /></>,
  mic: <><rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21" /></>,
  music: <><path d="M9 18V5.5l11-2V16" /><circle cx="6.5" cy="18" r="2.5" /><circle cx="17.5" cy="16" r="2.5" /></>,
  clock: <><circle cx="12" cy="12" r="8" /><path d="M12 7.5V12l3 2" /></>,
  alert: <><circle cx="12" cy="12" r="9" /><path d="M12 7.5v5.5M12 16.2v.3" /></>,
  photo: <><path d="M4 8.5A2.5 2.5 0 0 1 6.5 6h1.8l1.4-2h4.6l1.4 2h1.8A2.5 2.5 0 0 1 20 8.5v8a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 16.5z" /><circle cx="12" cy="12.5" r="3.4" /></>,
  left: <path d="M14.5 5l-7 7 7 7" />,
  right: <path d="M9.5 5l7 7-7 7" />,
};
function Ic({ n, s = 22, c, sw = 1.8, style }) {
  return (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c || 'currentColor'} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" style={{ display: 'block', flexShrink: 0, ...style }}>
      {ICONS[n]}
    </svg>
  );
}
function Verified({ s = 16 }) {
  return (
    <svg width={s} height={s} viewBox="0 0 24 24" style={{ flexShrink: 0, display: 'inline-block', verticalAlign: '-3px' }}>
      <path fill={T.link} d="M12 1.8l2.4 1.9 3-.2 1 2.9 2.6 1.6-.6 3 1.3 2.7-2.1 2.2-.2 3-2.9.9-1.7 2.5-2.9-.9-2.8 1.1-1.9-2.4-3-.5-.4-3-2.3-2 1.1-2.8-.8-2.9 2.6-1.5.8-2.9 3-.1z" />
      <path d="M8 12.2l2.7 2.7L16.2 9.4" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
function Checks({ read, c, s = 16 }) {
  return (
    <svg width={read ? s + 4 : s} height={s} viewBox={read ? '0 0 20 16' : '0 0 16 16'} fill="none" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'block', flexShrink: 0 }}>
      {read ? <><path d="M1.5 8.5l3.5 3.5 7-8" /><path d="M8.5 11.5l.5.5 7-8" /></> : <path d="M3 8.5l3.5 3.5 7-8" />}
    </svg>
  );
}

/* ─── avatar ──────────────────────────────────────────────────── */
const _noPhoto = new Set();
function Avatar({ id, name, size = 42, onClick, online, ringColor = T.side, big }) {
  const key = String(id || '');
  const [bad, setBad] = useState(() => !id || _noPhoto.has(key));
  useEffect(() => { setBad(!id || _noPhoto.has(key)); }, [id, key]);
  const g = AV_GRADS[peerIndex(id || name)];
  return (
    <div onClick={onClick} style={{ position: 'relative', width: size, height: size, flexShrink: 0, cursor: onClick ? 'pointer' : 'default' }}>
      {bad ? (
        <div style={{ width: size, height: size, borderRadius: '50%', background: `linear-gradient(180deg, ${g[0]}, ${g[1]})`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 600, fontSize: Math.round(size * 0.38), userSelect: 'none', letterSpacing: .3 }}>
          {initials(name)}
        </div>
      ) : (
        <img src={mediaUrl(`/photo/${id}`, big ? '&big=1' : '')} alt="" loading="lazy" draggable={false}
          onError={() => { _noPhoto.add(key); setBad(true); }}
          style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', display: 'block', background: T.input }} />
      )}
      {online && <span style={{ position: 'absolute', right: 0, bottom: 0, width: Math.max(10, size * 0.26), height: Math.max(10, size * 0.26), borderRadius: '50%', background: T.online, border: `2px solid ${ringColor}` }} />}
    </div>
  );
}

/* ─── rich text (Telegram entities) ───────────────────────────── */
function mkRe(src, flags, fallback) { try { return new RegExp(src, flags); } catch (e) { return fallback; } }
const URL_RE = mkRe(String.raw`((?:https?:\/\/|www\.)[^\s<]+[^\s<.,:;"')\]!?])|(@[A-Za-z0-9_]{4,32})|(#[\p{L}\p{N}_]+)`, 'gu', /((?:https?:\/\/|www\.)[^\s<]+[^\s<.,:;"')\]!?])|(@[A-Za-z0-9_]{4,32})|(#\w+)/g);
function linkify(str, kb) {
  const out = [];
  let last = 0, m;
  URL_RE.lastIndex = 0;
  while ((m = URL_RE.exec(str))) {
    if (m.index > last) out.push(str.slice(last, m.index));
    const k = kb + '_' + m.index;
    if (m[1]) out.push(<a key={k} href={/^https?:/i.test(m[1]) ? m[1] : 'https://' + m[1]} target="_blank" rel="noreferrer" className="tgc-link" onClick={e => e.stopPropagation()}>{m[1]}</a>);
    else if (m[2]) out.push(<a key={k} href={'https://t.me/' + m[2].slice(1)} target="_blank" rel="noreferrer" className="tgc-link" onClick={e => e.stopPropagation()}>{m[2]}</a>);
    else out.push(<span key={k} className="tgc-link">{m[3]}</span>);
    last = m.index + m[0].length;
  }
  if (last < str.length) out.push(str.slice(last));
  return out;
}
function Spoiler({ children }) {
  const [open, setOpen] = useState(false);
  return <span className={open ? '' : 'tgc-spoiler'} onClick={e => { if (!open) { e.stopPropagation(); setOpen(true); } }}>{children}</span>;
}
function wrapEntity(e, children, raw, key) {
  const stop = ev => ev.stopPropagation();
  switch (e.t) {
    case 'bold': return <b key={key} style={{ fontWeight: 600 }}>{children}</b>;
    case 'italic': return <i key={key}>{children}</i>;
    case 'underline': return <u key={key}>{children}</u>;
    case 'strike': return <s key={key}>{children}</s>;
    case 'code': return <code key={key} title="Kopyala" onClick={ev => { stop(ev); navigator.clipboard?.writeText(raw).catch(() => {}); }} style={{ background: 'rgba(0,0,0,.22)', borderRadius: 4, padding: '1px 4px', fontSize: '.9em', color: '#8ccfff', cursor: 'pointer' }}>{children}</code>;
    case 'pre': return <pre key={key} style={{ display: 'block', background: 'rgba(0,0,0,.24)', borderLeft: `3px solid ${T.link}`, borderRadius: 6, padding: '6px 10px', margin: '4px 0', whiteSpace: 'pre-wrap', fontSize: 13, color: '#cfe6ff', overflowX: 'auto' }}>{children}</pre>;
    case 'url': return <a key={key} href={/^https?:/i.test(raw) ? raw : 'https://' + raw} target="_blank" rel="noreferrer" className="tgc-link" onClick={stop}>{children}</a>;
    case 'texturl': return <a key={key} href={e.url} target="_blank" rel="noreferrer" className="tgc-link" onClick={stop}>{children}</a>;
    case 'email': return <a key={key} href={'mailto:' + raw} className="tgc-link" onClick={stop}>{children}</a>;
    case 'phone': return <a key={key} href={'tel:' + raw} className="tgc-link" onClick={stop}>{children}</a>;
    case 'mention': return <a key={key} href={'https://t.me/' + raw.replace(/^@/, '')} target="_blank" rel="noreferrer" className="tgc-link" onClick={stop}>{children}</a>;
    case 'mentionname': case 'hashtag': case 'cashtag': case 'botcommand': case 'bankcard':
      return <span key={key} className="tgc-link">{children}</span>;
    case 'spoiler': return <Spoiler key={key}>{children}</Spoiler>;
    case 'blockquote': return <span key={key} style={{ display: 'block', borderLeft: '3px solid currentColor', paddingLeft: 9, margin: '3px 0', opacity: .92 }}>{children}</span>;
    default: return <React.Fragment key={key}>{children}</React.Fragment>;
  }
}
function renderRich(text, ents) {
  if (!text) return null;
  if (!ents || !ents.length) return linkify(text, 'p');
  const list = ents.filter(e => e && e.l > 0 && e.o >= 0 && e.o < text.length).sort((a, b) => a.o - b.o || b.l - a.l);
  let k = 0;
  function build(start, end, items) {
    const out = [];
    let pos = start, i = 0;
    while (i < items.length) {
      const e = items[i];
      if (e.o < pos) { i++; continue; }
      if (e.o > pos) out.push(text.slice(pos, e.o));
      const eEnd = Math.min(e.o + e.l, end);
      const inner = items.slice(i + 1).filter(x => x.o >= e.o && x.o + x.l <= eEnd);
      out.push(wrapEntity(e, build(e.o, eEnd, inner), text.slice(e.o, eEnd), 'e' + (k++)));
      pos = eEnd;
      i++;
      while (i < items.length && items[i].o < pos) i++;
    }
    if (pos < end) out.push(text.slice(pos, end));
    return out;
  }
  return build(0, text.length, list);
}
function RichText({ text, entities }) {
  return useMemo(() => renderRich(text, entities), [text, entities]);
}

/* ─── hooks ───────────────────────────────────────────────────── */
function useInView(margin = '300px') {
  const ref = useRef(null);
  const [v, setV] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || v) return undefined;
    if (!('IntersectionObserver' in window)) { setV(true); return undefined; }
    const io = new IntersectionObserver(es => { if (es.some(x => x.isIntersecting)) { setV(true); io.disconnect(); } }, { rootMargin: margin });
    io.observe(el);
    return () => io.disconnect();
  }, [v, margin]);
  return [ref, v];
}

/* ─── media sizing ───────────────────────────────────────────── */
function fitSize(w, h, maxW, maxH) {
  if (!w || !h) return { w: maxW, h: Math.round(maxW * 0.68) };
  const s = Math.min(maxW / w, maxH / h);
  let dw = Math.round(w * s), dh = Math.round(h * s);
  if (dw < 180) dw = 180;
  if (dh < 90) dh = 90;
  return { w: dw, h: dh };
}
function albumLayout(items, W) {
  const ar = items.map(m => (m.w && m.h) ? Math.max(0.45, Math.min(2.4, m.w / m.h)) : 1);
  const n = items.length;
  let rows = [];
  if (n === 1) rows = [[0]];
  else if (n === 2) rows = [[0, 1]];
  else if (n === 3) rows = ar[0] > 1.15 ? [[0], [1, 2]] : [[0, 1, 2]];
  else if (n === 4) rows = ar[0] > 1.15 ? [[0], [1, 2, 3]] : [[0, 1], [2, 3]];
  else {
    const idx = items.map((_, i) => i);
    const r = n % 3;
    if (r === 1) { rows.push(idx.splice(0, 2)); rows.push(idx.splice(0, 2)); }
    else if (r === 2) rows.push(idx.splice(0, 2));
    while (idx.length) rows.push(idx.splice(0, 3));
  }
  const gap = 2, cells = [];
  let y = 0;
  for (const row of rows) {
    const sum = row.reduce((s, i) => s + ar[i], 0);
    const avail = W - gap * (row.length - 1);
    const h = Math.round(Math.min(avail / sum, row.length === 1 ? 330 : 230));
    let x = 0;
    for (let k = 0; k < row.length; k++) {
      const i = row[k];
      const w = k === row.length - 1 ? W - x : Math.round(avail * ar[i] / sum);
      cells[i] = { x, y, w, h };
      x += w + gap;
    }
    y += h + gap;
  }
  return { cells, height: y - gap };
}

/* ─── media atoms ─────────────────────────────────────────────── */
function Blur({ thumb }) {
  if (!thumb) return null;
  return <div style={{ position: 'absolute', inset: -12, backgroundImage: `url(${thumb})`, backgroundSize: 'cover', backgroundPosition: 'center', filter: 'blur(14px)', transform: 'scale(1.1)' }} />;
}
function PhotoTile({ msg, cid, w, h, onOpen, style }) {
  const [ok, setOk] = useState(false);
  const [err, setErr] = useState(false);
  return (
    <div className="tgc-media-hover" onClick={e => { e.stopPropagation(); onOpen && onOpen(msg); }}
      style={{ position: 'relative', width: w, height: h, overflow: 'hidden', background: '#0f1923', cursor: 'pointer', ...style }}>
      <Blur thumb={msg.thumb} />
      {!err && <img src={mUrl(cid, msg.id, '&size=preview')} alt="" loading="lazy" draggable={false}
        onLoad={() => setOk(true)} onError={() => setErr(true)}
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: ok ? 1 : 0, transition: 'opacity .25s' }} />}
      {!ok && !err && !msg.thumb && <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div className="tgc-spin" /></div>}
      {err && <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: T.dim }}><Ic n="image" s={34} /></div>}
    </div>
  );
}
function VideoTile({ msg, cid, w, h, onOpen, style }) {
  const [ok, setOk] = useState(false);
  return (
    <div className="tgc-media-hover" onClick={e => { e.stopPropagation(); onOpen && onOpen(msg); }}
      style={{ position: 'relative', width: w, height: h, overflow: 'hidden', background: '#0b1219', cursor: 'pointer', ...style }}>
      <Blur thumb={msg.thumb} />
      <img src={mUrl(cid, msg.id, '&size=thumb')} alt="" loading="lazy" draggable={false} onLoad={() => setOk(true)} onError={e => { e.target.style.display = 'none'; }}
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: ok ? 1 : 0, transition: 'opacity .25s' }} />
      <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)', width: 52, height: 52, borderRadius: '50%', background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
        <Ic n="play" s={26} style={{ marginLeft: 3 }} />
      </div>
      {msg.duration ? <span style={{ position: 'absolute', left: 6, top: 6, background: 'rgba(0,0,0,.5)', color: '#fff', fontSize: 12, padding: '1px 7px', borderRadius: 10 }}>{fmtDur(msg.duration)}</span> : null}
    </div>
  );
}
function GifTile({ msg, cid, w, h, onOpen, style }) {
  const [ref, inView] = useInView();
  return (
    <div ref={ref} onClick={e => { e.stopPropagation(); onOpen && onOpen(msg); }} style={{ position: 'relative', width: w, height: h, overflow: 'hidden', background: '#0b1219', cursor: 'pointer', ...style }}>
      <Blur thumb={msg.thumb} />
      {inView && <video src={mUrl(cid, msg.id)} autoPlay loop muted playsInline preload="auto" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />}
      <span style={{ position: 'absolute', left: 6, top: 6, background: 'rgba(0,0,0,.5)', color: '#fff', fontSize: 11, fontWeight: 700, padding: '1px 6px', borderRadius: 8 }}>GIF</span>
    </div>
  );
}
function VisualTile(props) {
  const t = props.msg.mediaType;
  if (t === 'video') return <VideoTile {...props} />;
  if (t === 'gif') return <GifTile {...props} />;
  return <PhotoTile {...props} />;
}

function Sticker({ msg, cid }) {
  const [ref, inView] = useInView();
  const size = 190;
  if (msg.stickerKind === 'video') {
    return <div ref={ref} style={{ width: size, height: size }}>{inView && <video src={mUrl(cid, msg.id)} autoPlay loop muted playsInline style={{ width: size, height: size, objectFit: 'contain' }} />}</div>;
  }
  const src = msg.stickerKind === 'tgs' ? mUrl(cid, msg.id, '&size=thumb') : mUrl(cid, msg.id);
  return <img src={src} alt={msg.text || 'sticker'} loading="lazy" draggable={false} style={{ width: size, height: size, objectFit: 'contain', display: 'block' }} onError={e => { e.target.style.visibility = 'hidden'; }} />;
}

function RoundVideo({ msg, cid }) {
  const [play, setPlay] = useState(false);
  return (
    <div onClick={e => { e.stopPropagation(); setPlay(p => !p); }} style={{ position: 'relative', width: 240, height: 240, borderRadius: '50%', overflow: 'hidden', cursor: 'pointer', background: '#0b1219' }}>
      <Blur thumb={msg.thumb} />
      {play
        ? <video src={mUrl(cid, msg.id)} autoPlay playsInline onEnded={() => setPlay(false)} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
        : <img src={mUrl(cid, msg.id, '&size=thumb')} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />}
      {!play && <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)', width: 52, height: 52, borderRadius: '50%', background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}><Ic n="play" s={26} style={{ marginLeft: 3 }} /></div>}
      {msg.duration ? <span style={{ position: 'absolute', left: '50%', bottom: 14, transform: 'translateX(-50%)', background: 'rgba(0,0,0,.5)', color: '#fff', fontSize: 12, padding: '1px 8px', borderRadius: 10 }}>{fmtDur(msg.duration)}</span> : null}
    </div>
  );
}

function AudioPlayer({ msg, cid, out, voice }) {
  const aRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [cur, setCur] = useState(0);
  const [dur, setDur] = useState(msg.duration || 0);
  const [loading, setLoading] = useState(false);
  const [started, setStarted] = useState(false);
  const fg = out ? '#ffffff' : T.link;
  const fgDim = out ? 'rgba(255,255,255,.35)' : 'rgba(106,179,243,.3)';
  const bars = useMemo(() => {
    const wf = msg.waveform && msg.waveform.length ? msg.waveform : Array.from({ length: 48 }, (_, i) => 6 + ((i * 7919 + msg.id) % 19));
    const N = 46, out2 = [];
    for (let i = 0; i < N; i++) out2.push(wf[Math.floor(i * wf.length / N)] || 0);
    const mx = Math.max(1, ...out2);
    return out2.map(v => 3 + Math.round((v / mx) * 17));
  }, [msg.waveform, msg.id]);

  function toggle(e) {
    e.stopPropagation();
    const a = aRef.current;
    if (!a) return;
    if (!started) { setStarted(true); setLoading(true); a.src = mUrl(cid, msg.id); }
    if (a.paused) {
      document.querySelectorAll('audio[data-tgc]').forEach(x => { if (x !== a) x.pause(); });
      a.play().catch(() => setLoading(false));
    } else a.pause();
  }
  function seek(e) {
    e.stopPropagation();
    const a = aRef.current;
    if (!a) return;
    if (!started || !dur) { toggle(e); return; }
    const r = e.currentTarget.getBoundingClientRect();
    const p = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
    a.currentTime = p * dur;
    if (a.paused) a.play().catch(() => {});
  }
  const prog = dur ? cur / dur : 0;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 11, minWidth: voice ? 230 : 260, padding: '2px 0' }}>
      <audio data-tgc="1" ref={aRef} preload="none"
        onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onPlaying={() => setLoading(false)} onWaiting={() => setLoading(true)}
        onEnded={() => { setPlaying(false); setCur(0); }} onTimeUpdate={e => setCur(e.target.currentTime)}
        onLoadedMetadata={e => { if (isFinite(e.target.duration)) setDur(e.target.duration); }} />
      <button onClick={toggle} style={{ width: 44, height: 44, borderRadius: '50%', border: 'none', background: out ? '#fff' : T.accent, color: out ? T.out : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0, position: 'relative' }}>
        {loading && playing === false && started ? <div className="tgc-spin" style={{ width: 22, height: 22, borderTopColor: out ? T.out : '#fff' }} /> : <Ic n={playing ? 'pause' : 'play'} s={22} style={{ marginLeft: playing ? 0 : 2 }} />}
      </button>
      <div style={{ flex: 1, minWidth: 0 }}>
        {voice ? (
          <div onClick={seek} style={{ display: 'flex', alignItems: 'center', gap: 2, height: 24, cursor: 'pointer' }}>
            {bars.map((b, i) => <div key={i} style={{ width: 3, height: b, borderRadius: 2, background: (i / bars.length) < prog ? fg : fgDim, flexShrink: 0 }} />)}
          </div>
        ) : (
          <>
            <div style={{ fontSize: 14, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{msg.title || msg.fileName || 'Ses dosyası'}</div>
            <div style={{ fontSize: 13, color: out ? T.metaOut : T.sub, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{msg.performer || fmtSize(msg.fileSize)}</div>
            <div onClick={seek} style={{ height: 14, display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <div style={{ height: 3, flex: 1, borderRadius: 2, background: fgDim, position: 'relative' }}><div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: (prog * 100) + '%', background: fg, borderRadius: 2 }} /></div>
            </div>
          </>
        )}
        <div style={{ fontSize: 12.5, color: out ? T.metaOut : T.sub, marginTop: voice ? 3 : 0 }}>{playing || cur ? fmtDur(cur) + ' / ' : ''}{fmtDur(dur)}</div>
      </div>
    </div>
  );
}

function FileBox({ msg, cid, out }) {
  const ext = (msg.fileName || '').split('.').pop();
  const showExt = ext && ext.length <= 4 && ext !== msg.fileName;
  return (
    <a href={mUrl(cid, msg.id, '&dl=1&name=' + encodeURIComponent(msg.fileName || 'dosya'))} download={msg.fileName || 'dosya'} onClick={e => e.stopPropagation()}
      style={{ display: 'flex', alignItems: 'center', gap: 11, textDecoration: 'none', color: 'inherit', minWidth: 230, maxWidth: 360, padding: '2px 0' }}>
      <div style={{ width: 46, height: 46, borderRadius: '50%', background: out ? '#fff' : T.accent, color: out ? T.out : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: 11, fontWeight: 700, textTransform: 'uppercase' }}>
        {showExt ? ext.slice(0, 4) : <Ic n="file" s={22} />}
      </div>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: 14, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{msg.fileName || 'Dosya'}</div>
        <div style={{ fontSize: 13, color: out ? T.metaOut : T.sub, display: 'flex', alignItems: 'center', gap: 4 }}>{fmtSize(msg.fileSize)} <Ic n="download" s={14} /></div>
      </div>
    </a>
  );
}

function WebPreview({ msg, cid, out }) {
  const wp = msg.webpage;
  if (!wp) return null;
  const bar = out ? '#a8d7ff' : T.link;
  return (
    <a href={wp.url} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}
      style={{ display: 'block', borderLeft: `3px solid ${bar}`, background: hexA(bar, 0.09), borderRadius: '4px 8px 8px 4px', padding: '6px 10px 8px', marginTop: 6, textDecoration: 'none', color: 'inherit', maxWidth: 420 }}>
      {wp.siteName && <div style={{ color: bar, fontWeight: 600, fontSize: 13.5 }}>{wp.siteName}</div>}
      {wp.title && <div style={{ fontWeight: 600, fontSize: 14, marginTop: 1 }}>{wp.title}</div>}
      {wp.description && <div style={{ fontSize: 13.5, opacity: .9, marginTop: 2, display: '-webkit-box', WebkitLineClamp: 4, WebkitBoxOrient: 'vertical', overflow: 'hidden', whiteSpace: 'pre-wrap' }}>{wp.description}</div>}
      {wp.hasPhoto && (
        <div style={{ position: 'relative', marginTop: 7, borderRadius: 7, overflow: 'hidden', background: '#0f1923', height: 190 }}>
          <Blur thumb={msg.thumb} />
          <img src={mUrl(cid, msg.id, '&size=preview')} alt="" loading="lazy" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
        </div>
      )}
    </a>
  );
}

function PollBox({ poll, out }) {
  const total = poll.total || 0;
  const fg = out ? '#fff' : T.link;
  return (
    <div style={{ minWidth: 250, maxWidth: 380, padding: '2px 0' }}>
      <div style={{ fontWeight: 600, fontSize: 14.5, marginBottom: 2 }}>{poll.question}</div>
      <div style={{ fontSize: 12.5, color: out ? T.metaOut : T.sub, marginBottom: 8 }}>{poll.quiz ? 'Test' : (poll.publicVoters ? 'Anket' : 'Anonim anket')}{poll.closed ? ' · Sonuçlandı' : ''}</div>
      {poll.answers.map((a, i) => {
        const pct = total ? Math.round((a.voters / total) * 100) : 0;
        return (
          <div key={i} style={{ marginBottom: 8 }}>
            <div style={{ display: 'flex', gap: 8, fontSize: 14 }}>
              <span style={{ fontWeight: 700, minWidth: 34, fontSize: 13 }}>{total ? pct + '%' : ''}</span>
              <span style={{ flex: 1 }}>{a.text} {a.chosen ? '✓' : ''}</span>
            </div>
            <div style={{ height: 4, borderRadius: 2, marginTop: 4, marginLeft: 42, background: out ? 'rgba(255,255,255,.15)' : 'rgba(106,179,243,.15)' }}>
              <div style={{ width: Math.max(2, pct) + '%', height: '100%', borderRadius: 2, background: a.correct ? T.online : fg }} />
            </div>
          </div>
        );
      })}
      <div style={{ fontSize: 12.5, color: out ? T.metaOut : T.sub, textAlign: 'center' }}>{total ? total.toLocaleString('tr-TR') + ' oy' : 'Henüz oy yok'}</div>
    </div>
  );
}

function OtherMedia({ msg, cid, out }) {
  const t = msg.mediaType;
  if (t === 'voice') return <AudioPlayer msg={msg} cid={cid} out={out} voice />;
  if (t === 'audio') return <AudioPlayer msg={msg} cid={cid} out={out} />;
  if (t === 'file') return <FileBox msg={msg} cid={cid} out={out} />;
  if (t === 'poll' && msg.poll) return <PollBox poll={msg.poll} out={out} />;
  if (t === 'location') {
    const g = msg.geo || {};
    return (
      <a href={g.lat ? `https://maps.google.com/?q=${g.lat},${g.long}` : '#'} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}
        style={{ display: 'flex', alignItems: 'center', gap: 11, textDecoration: 'none', color: 'inherit', minWidth: 230 }}>
        <div style={{ width: 46, height: 46, borderRadius: '50%', background: out ? '#fff' : T.accent, color: out ? T.out : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Ic n="location" s={22} /></div>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontWeight: 600 }}>{g.title || 'Konum'}</div>
          <div style={{ fontSize: 13, color: out ? T.metaOut : T.sub }}>{g.address || (g.lat ? g.lat.toFixed(5) + ', ' + g.long.toFixed(5) : '')}</div>
        </div>
      </a>
    );
  }
  if (t === 'contact' && msg.contact) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 11, minWidth: 220 }}>
        <Avatar name={msg.contact.name} id={null} size={46} />
        <div>
          <div style={{ fontWeight: 600 }}>{msg.contact.name || 'Kişi'}</div>
          <div style={{ fontSize: 13, color: out ? T.metaOut : T.sub }}>{msg.contact.phone}</div>
        </div>
      </div>
    );
  }
  return null;
}

/* ─── message parts ───────────────────────────────────────────── */
function Meta({ msg, out, overlay, showViews, read }) {
  const col = overlay ? '#fff' : (out ? T.metaOut : T.metaIn);
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, color: col, whiteSpace: 'nowrap', userSelect: 'none', lineHeight: 1,
      ...(overlay ? { background: 'rgba(0,0,0,.45)', padding: '4px 7px', borderRadius: 11 } : {}) }}>
      {showViews && msg.views > 0 && <><Ic n="eye" s={14} c={col} sw={1.7} /><span style={{ marginRight: 3 }}>{fmtCount(msg.views)}</span></>}
      {msg.editDate && <span>düzenlendi</span>}
      {msg.postAuthor && <span style={{ maxWidth: 110, overflow: 'hidden', textOverflow: 'ellipsis' }}>{msg.postAuthor},</span>}
      <span>{fmtTime(msg.date)}</span>
      {out && (msg._failed ? <Ic n="alert" s={15} c={T.danger} /> : msg._pending ? <Ic n="clock" s={14} c={col} /> : <Checks read={read} c={overlay ? '#fff' : (read ? '#8fd0ff' : col)} />)}
    </span>
  );
}
function metaWidth(msg, out, showViews) {
  let w = 40;
  if (msg.editDate) w += 66;
  if (showViews && msg.views > 0) w += 22 + fmtCount(msg.views).length * 7;
  if (msg.postAuthor) w += Math.min(110, msg.postAuthor.length * 6.5) + 6;
  if (out) w += 22;
  return w;
}

function ReplyBox({ r, out, isGroup, onJump }) {
  const color = out ? '#b9dcff' : (isGroup && r.fromId ? nameColor(r.fromId) : T.link);
  return (
    <div onClick={e => { e.stopPropagation(); onJump && r.id && onJump(r.id); }}
      style={{ display: 'flex', gap: 8, alignItems: 'center', borderLeft: `3px solid ${color}`, background: hexA(color, out ? 0.13 : 0.1), borderRadius: '4px 7px 7px 4px', padding: '4px 9px 4px 8px', marginBottom: 5, cursor: 'pointer', minWidth: 0, maxWidth: '100%' }}>
      {r.thumb && VISUAL[r.mediaType] && <img src={r.thumb} alt="" style={{ width: 34, height: 34, borderRadius: 4, objectFit: 'cover', flexShrink: 0 }} />}
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ color, fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.fromName || 'Mesaj'}</div>
        <div style={{ fontSize: 13.5, color: out ? 'rgba(255,255,255,.88)' : '#d3dce5', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{(r.text || '').replace(/\s+/g, ' ') || 'Mesaj'}</div>
      </div>
    </div>
  );
}

function BubbleTail({ out, color }) {
  return (
    <svg width="9" height="17" viewBox="0 0 9 17" style={{ position: 'absolute', bottom: 0, [out ? 'right' : 'left']: -8, display: 'block' }}>
      <path d={out ? 'M6 17H0V0c.19 2.84.88 5.77 2.05 8.78.9 2.33 2.45 4.49 4.62 6.48A1 1 0 0 1 6 17z' : 'M3 17h6V0c-.19 2.84-.88 5.77-2.05 8.78-.9 2.33-2.45 4.49-4.62 6.48A1 1 0 0 0 3 17z'} fill={color} />
    </svg>
  );
}

/* ─── one message row ─────────────────────────────────────────── */
function MessageRow({ item, first, last, ctx }) {
  const isAlbum = item.type === 'album';
  const msg = isAlbum ? item.items[item.items.length - 1] : item;
  const head = isAlbum ? item.items[0] : item;
  const { isGroup, isBroadcast, cid } = ctx;
  const out = !!msg.out && !isBroadcast;
  const selected = ctx.selected.has(msg.id) || (isAlbum && item.items.some(x => ctx.selected.has(x.id)));
  const read = !!msg.out && (msg._read || (ctx.readMax && typeof msg.id === 'number' && msg.id <= ctx.readMax));

  if (msg.service) {
    return (
      <div data-mid={msg.id} style={{ display: 'flex', justifyContent: 'center', padding: '6px 0' }}>
        <span style={{ background: 'rgba(30,44,58,.85)', color: '#e8edf2', fontSize: 13, padding: '4px 12px', borderRadius: 14, maxWidth: '80%', textAlign: 'center' }}>{msg.service}</span>
      </div>
    );
  }

  const caption = isAlbum ? item.items.find(x => x.text) : (msg.text ? msg : null);
  const capText = caption ? caption.text : '';
  const capEnts = caption ? caption.entities : null;
  const mt = isAlbum ? 'album' : msg.mediaType;
  const visual = isAlbum || VISUAL[mt];
  const naked = mt === 'sticker' || mt === 'round' || (!mt && !msg.fwdFrom && !head.replyToMsgId && EMOJI_ONLY_RE.test(capText || '') && !!capText.trim());
  const showName = isGroup && !out && first;
  const senderName = msg.fromName || (msg.postAuthor) || 'Bilinmeyen';
  const sColor = nameColor(msg.fromId || senderName);
  const showViews = isBroadcast || (!!msg.fwdFrom && msg.views > 0);
  const reply = head.replyToMsgId ? (head.replyTo || ctx.previewOf(head.replyToMsgId) || { id: head.replyToMsgId, text: 'Yanıtlanan mesaj' }) : null;
  const reactions = msg.reactions && msg.reactions.length ? msg.reactions : null;

  const maxW = isBroadcast ? 480 : 400;
  let mediaW = 0, mediaH = 0, layout = null;
  if (isAlbum) {
    mediaW = maxW;
    layout = albumLayout(item.items, mediaW);
    mediaH = layout.height;
  } else if (visual) {
    const s = fitSize(msg.w, msg.h, maxW, isBroadcast ? 520 : 440);
    mediaW = s.w; mediaH = s.h;
  }

  const bg = out ? T.out : T.in;
  const R = 15, r = 6;
  const tail = last && !naked && !(visual && !capText);
  const radius = out
    ? `${R}px ${first ? R : r}px ${tail ? 0 : (last ? R : r)}px ${R}px`
    : `${first ? R : r}px ${R}px ${R}px ${tail ? 0 : (last ? R : r)}px`;

  const hasHeader = showName || msg.fwdFrom || reply;
  const metaInline = !!capText && !msg.webpage && !reactions && !naked;
  const metaOverlay = (visual && !capText && !reactions) || naked;
  const metaFooter = !metaInline && !metaOverlay;
  const mw = metaWidth(msg, out, showViews);

  function onContext(e) {
    e.preventDefault();
    ctx.openMenu(e, isAlbum ? item.items : [msg]);
  }
  function onClick() {
    if (ctx.selectMode) (isAlbum ? item.items : [msg]).forEach(x => ctx.toggleSelect(x.id, !selected));
  }

  const header = hasHeader ? (
    <div style={{ padding: visual ? '6px 10px 6px' : 0 }}>
      {showName && (
        <div onClick={e => { e.stopPropagation(); msg.fromId && ctx.onSender(msg.fromId, senderName); }}
          style={{ color: sColor, fontWeight: 600, fontSize: 14, marginBottom: 2, cursor: msg.fromId ? 'pointer' : 'default', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {senderName}
        </div>
      )}
      {msg.fwdFrom && (
        <div style={{ fontSize: 13.5, color: out ? '#b9dcff' : T.link, marginBottom: 3, lineHeight: 1.3 }}>
          <div style={{ opacity: .85 }}>İletilen mesaj</div>
          <div style={{ fontWeight: 600 }}>{msg.fwdFrom.fromName || msg.fwdFrom.postAuthor || 'Gizli kullanıcı'}</div>
        </div>
      )}
      {reply && <ReplyBox r={reply} out={out} isGroup={isGroup} onJump={ctx.jumpTo} />}
    </div>
  ) : null;

  let body;
  if (naked) {
    body = (
      <div style={{ position: 'relative', display: 'inline-block' }}>
        {hasHeader && <div style={{ background: bg, borderRadius: 12, padding: '6px 10px', marginBottom: 4, maxWidth: 260 }}>{header}</div>}
        {mt === 'sticker' ? <Sticker msg={msg} cid={cid} /> : mt === 'round' ? <RoundVideo msg={msg} cid={cid} /> : <div style={{ fontSize: 46, lineHeight: 1.15 }}>{capText}</div>}
        <div style={{ display: 'flex', justifyContent: out ? 'flex-end' : 'flex-start', marginTop: 2 }}>
          <Meta msg={msg} out={out} overlay read={read} showViews={showViews} />
        </div>
      </div>
    );
  } else {
    body = (
      <div style={{ position: 'relative', maxWidth: '100%' }}>
        {tail && <BubbleTail out={out} color={bg} />}
        <div className={out ? 'tgc-out' : ''} style={{ background: bg, borderRadius: radius, width: visual ? mediaW : undefined, maxWidth: visual ? '100%' : Math.min(isBroadcast ? 520 : 480, 99999), minWidth: visual ? undefined : 64, overflow: visual ? 'hidden' : 'visible', position: 'relative', boxShadow: '0 1px 2px rgba(0,0,0,.18)' }}>
          {visual ? header : null}
          {visual && (
            isAlbum ? (
              <div style={{ position: 'relative', width: mediaW, height: mediaH, maxWidth: '100%' }}>
                {item.items.map((m, i) => {
                  const c = layout.cells[i];
                  return <VisualTile key={m.id} msg={m} cid={cid} w={c.w} h={c.h} onOpen={ctx.openViewer} style={{ position: 'absolute', left: c.x, top: c.y }} />;
                })}
              </div>
            ) : <VisualTile msg={msg} cid={cid} w={mediaW} h={mediaH} onOpen={ctx.openViewer} />
          )}
          {visual && metaOverlay && <div style={{ position: 'absolute', right: 7, bottom: 7 }}><Meta msg={msg} out={out} overlay read={read} showViews={showViews} /></div>}

          {(!visual || capText || metaFooter) && (
            <div style={{ padding: visual ? '6px 10px 7px' : '6px 10px 7px 11px', position: 'relative' }}>
              {!visual && header}
              {!visual && mt && mt !== 'webpage' && <OtherMedia msg={msg} cid={cid} out={out} />}
              {capText && (
                <div style={{ fontSize: 14.5, lineHeight: 1.42, whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginTop: (!visual && mt && mt !== 'webpage') ? 6 : 0 }}>
                  <RichText text={capText} entities={capEnts} />
                  {metaInline && <span style={{ display: 'inline-block', width: mw, height: 1 }} />}
                </div>
              )}
              {mt === 'webpage' && <WebPreview msg={msg} cid={cid} out={out} />}
              {metaInline && <div style={{ position: 'absolute', right: 9, bottom: 6 }}><Meta msg={msg} out={out} read={read} showViews={showViews} /></div>}
              {metaFooter && (
                <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 10, marginTop: 4 }}>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                    {reactions && reactions.map((x, i) => (
                      <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 13.5, background: x.chosen ? (out ? '#fff' : T.accent) : (out ? 'rgba(255,255,255,.14)' : 'rgba(106,179,243,.14)'), color: x.chosen ? (out ? T.out : '#fff') : (out ? '#fff' : T.link), borderRadius: 14, padding: '3px 9px', fontWeight: 600 }}>
                        <span style={{ fontSize: 15 }}>{x.emoticon}</span>{fmtCount(x.count)}
                      </span>
                    ))}
                  </div>
                  <Meta msg={msg} out={out} read={read} showViews={showViews} />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }

  const avatarCol = isGroup && !out;
  return (
    <div data-mid={msg.id} className={ctx.flashId === msg.id || (isAlbum && item.items.some(x => x.id === ctx.flashId)) ? 'tgc-flash' : ''}
      onContextMenu={onContext} onClick={onClick}
      style={{ display: 'flex', alignItems: 'flex-end', justifyContent: out ? 'flex-end' : 'flex-start', padding: `${first ? 5 : 1}px 0 ${last ? 3 : 1}px`, position: 'relative', cursor: ctx.selectMode ? 'pointer' : 'default', borderRadius: 8, background: selected ? 'rgba(82,136,193,.18)' : 'transparent' }}>
      {ctx.selectMode && (
        <div style={{ position: 'absolute', left: -34, bottom: 8, width: 22, height: 22, borderRadius: '50%', border: `2px solid ${selected ? T.accent : '#5d6d7e'}`, background: selected ? T.accent : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
          {selected && <Ic n="check" s={14} sw={3} />}
        </div>
      )}
      {avatarCol && (
        <div style={{ width: 44, flexShrink: 0, alignSelf: 'flex-end' }}>
          {last && <Avatar id={msg.fromId} name={senderName} size={36} ringColor={T.bg} onClick={e => { e.stopPropagation(); msg.fromId && ctx.onSender(msg.fromId, senderName); }} />}
        </div>
      )}
      <div style={{ maxWidth: avatarCol ? 'calc(100% - 44px)' : (isBroadcast ? '100%' : '82%'), minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: out ? 'flex-end' : 'flex-start' }}>
        {body}
      </div>
    </div>
  );
}

/* ─── modals / overlays ───────────────────────────────────────── */
function Modal({ onClose, children, w = 380, pad = 22 }) {
  return (
    <div onMouseDown={e => e.target === e.currentTarget && onClose()} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', zIndex: 7000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div className="tgc-fade" style={{ background: T.side, borderRadius: 14, padding: pad, width: w, maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 16px 50px rgba(0,0,0,.6)', color: T.text }}>
        {children}
      </div>
    </div>
  );
}
function TextBtn({ children, onClick, danger, disabled, style }) {
  return <button onClick={onClick} disabled={disabled} style={{ background: 'none', border: 'none', color: danger ? T.danger : T.link, fontWeight: 600, fontSize: 14, padding: '9px 14px', borderRadius: 8, cursor: disabled ? 'default' : 'pointer', opacity: disabled ? .5 : 1, fontFamily: 'inherit', textTransform: 'uppercase', letterSpacing: .3, ...style }}
    onMouseEnter={e => { if (!disabled) e.currentTarget.style.background = 'rgba(106,179,243,.1)'; }} onMouseLeave={e => { e.currentTarget.style.background = 'none'; }}>{children}</button>;
}

function MediaViewer({ state, onClose, onNav }) {
  const { items, index } = state;
  const it = items[index];
  useEffect(() => {
    const h = e => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft' && index > 0) onNav(index - 1);
      if (e.key === 'ArrowRight' && index < items.length - 1) onNav(index + 1);
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [index, items.length, onClose, onNav]);
  if (!it) return null;
  const navBtn = (dir) => (
    <button onClick={e => { e.stopPropagation(); onNav(index + dir); }} style={{ position: 'fixed', top: '50%', [dir < 0 ? 'left' : 'right']: 16, transform: 'translateY(-50%)', width: 52, height: 52, borderRadius: '50%', border: 'none', background: 'rgba(255,255,255,.08)', color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2 }}>
      <Ic n={dir < 0 ? 'left' : 'right'} s={28} />
    </button>
  );
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.92)', zIndex: 9000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div onClick={e => e.stopPropagation()} style={{ position: 'fixed', top: 0, left: 0, right: 0, display: 'flex', alignItems: 'center', gap: 12, padding: '10px 16px', background: 'linear-gradient(rgba(0,0,0,.6), transparent)', zIndex: 3 }}>
        {it.fromName !== undefined && <Avatar id={it.fromId} name={it.fromName || '?'} size={38} ringColor="#000" />}
        <div style={{ flex: 1, minWidth: 0, color: '#fff' }}>
          <div style={{ fontWeight: 600, fontSize: 14.5 }}>{it.fromName || ''}</div>
          <div style={{ fontSize: 13, opacity: .7 }}>{it.date ? new Date(it.date * 1000).toLocaleString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : ''}{items.length > 1 ? `  ·  ${index + 1} / ${items.length}` : ''}</div>
        </div>
        <a href={it.dl || (it.src + '&dl=1')} download target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()} className="tgc-btn" style={{ color: '#fff' }} title="İndir"><Ic n="download" /></a>
        <button className="tgc-btn" style={{ color: '#fff' }} onClick={onClose} title="Kapat"><Ic n="close" /></button>
      </div>
      {index > 0 && navBtn(-1)}
      {index < items.length - 1 && navBtn(1)}
      <div onClick={e => e.stopPropagation()} style={{ maxWidth: '92vw', maxHeight: '84vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {it.kind === 'video' || it.kind === 'gif'
          ? <video key={it.src} src={it.src} controls={it.kind === 'video'} autoPlay loop={it.kind === 'gif'} muted={it.kind === 'gif'} playsInline style={{ maxWidth: '92vw', maxHeight: '84vh', borderRadius: 4, background: '#000' }} />
          : <img key={it.src} src={it.src} alt="" style={{ maxWidth: '92vw', maxHeight: '84vh', objectFit: 'contain', userSelect: 'none', borderRadius: 2 }} />}
      </div>
      {it.caption && (
        <div onClick={e => e.stopPropagation()} style={{ position: 'fixed', bottom: 18, left: '50%', transform: 'translateX(-50%)', maxWidth: 'min(720px, 90vw)', background: 'rgba(0,0,0,.55)', color: '#fff', padding: '8px 14px', borderRadius: 10, fontSize: 14, whiteSpace: 'pre-wrap', maxHeight: '20vh', overflowY: 'auto' }}>
          {it.caption}
        </div>
      )}
    </div>
  );
}

/* ─── auth screens ────────────────────────────────────────────── */
function AuthCard({ title, sub, children }) {
  return (
    <div className="tgc" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 'var(--tg-h, calc(100vh - 48px))', background: T.bg, borderRadius: 'var(--tg-radius, 12px)' }}>
      <style>{CSS}</style>
      <div style={{ width: 360, maxWidth: '92vw', textAlign: 'center', padding: 8 }}>
        <div style={{ width: 120, height: 120, borderRadius: '50%', background: 'linear-gradient(180deg,#5eb5f7,#2a8ee0)', margin: '0 auto 26px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
          <Ic n="send" s={62} style={{ transform: 'translateX(-3px) rotate(-8deg)' }} />
        </div>
        <div style={{ fontSize: 24, fontWeight: 600, marginBottom: 8 }}>{title}</div>
        <div style={{ fontSize: 14.5, color: T.sub, marginBottom: 26, lineHeight: 1.5 }}>{sub}</div>
        {children}
      </div>
    </div>
  );
}
const authInp = { width: '100%', background: 'transparent', border: `1.5px solid ${T.input}`, borderRadius: 10, padding: '14px 16px', fontSize: 16, color: T.text, outline: 'none', marginBottom: 12, fontFamily: 'inherit' };
const authBtn = (ld) => ({ width: '100%', background: T.accent, border: 'none', borderRadius: 10, padding: 14, fontSize: 15, fontWeight: 600, color: '#fff', cursor: ld ? 'default' : 'pointer', opacity: ld ? .7 : 1, textTransform: 'uppercase', letterSpacing: .5, fontFamily: 'inherit' });

function PwScreen({ onOk }) {
  const [v, setV] = useState(''); const [err, setErr] = useState(''); const [ld, setLd] = useState(false);
  async function go(e) { e.preventDefault(); setLd(true); setErr(''); try { await api.post('/tg-client/verify-password', { password: v }); onOk(); } catch { setErr('Yanlış şifre'); } setLd(false); }
  return (
    <AuthCard title="Telegram Modülü" sub="Erişim için modül şifresini girin">
      <form onSubmit={go}>
        <input type="password" value={v} onChange={e => setV(e.target.value)} placeholder="Şifre" autoFocus style={authInp}
          onFocus={e => { e.target.style.borderColor = T.accent; }} onBlur={e => { e.target.style.borderColor = T.input; }} />
        {err && <div style={{ color: T.danger, fontSize: 13.5, marginBottom: 10 }}>{err}</div>}
        <button type="submit" disabled={ld} style={authBtn(ld)}>{ld ? 'Kontrol ediliyor…' : 'Devam'}</button>
      </form>
    </AuthCard>
  );
}

function LoginScreen({ onLogin }) {
  const [phone, setPhone] = useState(''); const [code, setCode] = useState(''); const [pw2fa, setPw2fa] = useState('');
  const [step, setStep] = useState('phone'); const [need2fa, setNeed2fa] = useState(false);
  const [ld, setLd] = useState(false); const [err, setErr] = useState('');
  async function start(e) { e.preventDefault(); setLd(true); setErr(''); try { await api.post('/tg-client/login/start', { phone }); setStep('code'); } catch (ex) { setErr(ex.response?.data?.error || ex.message); } setLd(false); }
  async function verify(e) {
    e.preventDefault(); setLd(true); setErr('');
    try { const r = await api.post('/tg-client/login/verify', { code, password: pw2fa || undefined }); onLogin(r.data.me); }
    catch (ex) { if (ex.response?.data?.need2fa) setNeed2fa(true); else setErr(ex.response?.data?.error || ex.message); }
    setLd(false);
  }
  return (
    <AuthCard title={step === 'phone' ? 'Telegram\'a giriş' : need2fa ? 'İki adımlı doğrulama' : phone}
      sub={step === 'phone' ? 'Ülke kodu ile birlikte telefon numaranızı girin.' : need2fa ? 'Hesabınız ek bir şifre ile korunuyor.' : 'Telegram uygulamanıza gönderilen kodu girin.'}>
      <form onSubmit={step === 'phone' ? start : verify}>
        {step === 'phone' && <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="+90 5xx xxx xx xx" autoFocus style={authInp} />}
        {step === 'code' && !need2fa && <input value={code} onChange={e => setCode(e.target.value)} maxLength={6} autoFocus placeholder="Kod" style={{ ...authInp, letterSpacing: 10, fontSize: 22, textAlign: 'center' }} />}
        {need2fa && <input type="password" value={pw2fa} onChange={e => setPw2fa(e.target.value)} autoFocus placeholder="Şifre" style={authInp} />}
        {err && <div style={{ color: T.danger, fontSize: 13.5, marginBottom: 10 }}>{err}</div>}
        <button type="submit" disabled={ld} style={authBtn(ld)}>{ld ? 'Lütfen bekleyin…' : step === 'phone' ? 'İleri' : 'Giriş yap'}</button>
        {step === 'code' && <button type="button" onClick={() => { setStep('phone'); setNeed2fa(false); }} style={{ ...authBtn(false), background: 'none', color: T.link, marginTop: 8 }}>Numarayı değiştir</button>}
      </form>
    </AuthCard>
  );
}

const EMOJIS = ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩', '🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '😣', '😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓', '🤗', '🤔', '🤭', '🤫', '🤥', '😶', '😐', '😑', '😬', '🙄', '😯', '😦', '😮', '😲', '🥱', '😴', '🤤', '😪', '😵', '🤐', '🥴', '🤢', '🤮', '🤧', '😷', '🤒', '🤕', '🤑', '🤠', '😈', '👿', '💀', '👻', '👽', '🤖', '💩', '👍', '👎', '👌', '🤌', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '👇', '☝️', '✋', '🤚', '🖐', '🖖', '👋', '👏', '🙌', '👐', '🤲', '🙏', '🤝', '💪', '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💯', '🔥', '✨', '⭐', '🌟', '⚡', '🎉', '🎊', '🎁', '🏆', '⚽', '🎯', '💰', '💵', '💸', '📌', '📎', '✅', '❌', '⚠️', '❓', '❗', '🆗', '🚀', '☕', '🍺', '🍕', '🌹', '🇹🇷', '🇬🇪'];

/* ══════════════════════════════════════════════════════════════
   MAIN
══════════════════════════════════════════════════════════════ */
export default function TelegramClient() {
  const [pwOk, setPwOk] = useState(false);
  const [conn, setConn] = useState(false);
  const [me, setMe] = useState(null);
  const [init, setInit] = useState(true);

  const [dls, setDls] = useState([]);
  const [dlLoading, setDlLoading] = useState(false);
  const [dlSrch, setDlSrch] = useState('');
  const [dlFlt, setDlFlt] = useState('all');
  const [showArchived, setShowArchived] = useState(false);
  const [sel, setSel] = useState(null);

  const [msgs, setMsgs] = useState([]);
  const [msgLoading, setMsgLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [peer, setPeer] = useState(null);
  const [readMax, setReadMax] = useState(0);

  const [txt, setTxt] = useState('');
  const [replyTo, setReplyTo] = useState(null);
  const [editM, setEditM] = useState(null);
  const [sending, setSending] = useState(false);

  const [viewer, setViewer] = useState(null);
  const [panel, setPanel] = useState(false);
  const [panelTab, setPanelTab] = useState('photo_video');
  const [panelItems, setPanelItems] = useState([]);
  const [panelLoading, setPanelLoading] = useState(false);
  const [peerBlocked, setPeerBlocked] = useState(false);

  const [meModal, setMeModal] = useState(false);
  const [meForm, setMeForm] = useState({});
  const [meEd, setMeEd] = useState(false);
  const [mainMenu, setMainMenu] = useState(false);

  const [typingPeers, setTypingPeers] = useState({});
  const [wsReady, setWsReady] = useState(false);
  const [pinnedMsg, setPinnedMsg] = useState(null);
  const [emojiOpen, setEmojiOpen] = useState(false);
  const [attachMenu, setAttachMenu] = useState(false);
  const [fwd, setFwd] = useState(null);
  const [fwdQ, setFwdQ] = useState('');
  const [selectMode, setSelectMode] = useState(false);
  const [selected, setSelected] = useState(new Set());
  const [dlMenu, setDlMenu] = useState(null);
  const [ctxMenu, setCtxMenu] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [headMenu, setHeadMenu] = useState(false);
  const [toast, setToast] = useState(null);

  const [gRes, setGRes] = useState([]);
  const [gSearching, setGSearching] = useState(false);
  const gTimer = useRef(null);

  const [chatSearch, setChatSearch] = useState(null);
  const csTimer = useRef(null);

  const [senderProfile, setSenderProfile] = useState(null);
  const [pendingFile, setPendingFile] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [showFab, setShowFab] = useState(false);
  const [newCount, setNewCount] = useState(0);
  const [flashId, setFlashId] = useState(null);
  const [narrow, setNarrow] = useState(() => window.innerWidth < 900);

  const listRef = useRef(null);
  const txRef = useRef(null);
  const mediaInRef = useRef(null);
  const fileInRef = useRef(null);
  const wsRef = useRef(null);
  const wsClosed = useRef(false);
  const selRef = useRef(null);
  const atBottomRef = useRef(true);
  const scrollMode = useRef(null);
  const prevScroll = useRef({ h: 0, top: 0 });
  const jumpTarget = useRef(null);
  const loadingRef = useRef(false);
  const reqId = useRef(0);
  const typingSent = useRef(0);
  const dragDepth = useRef(0);
  const onWsRef = useRef(() => {});
  selRef.current = sel;

  /* ── lifecycle ── */
  useEffect(() => { if (pwOk) load(); }, [pwOk]);
  useEffect(() => {
    if (!conn) return undefined;
    wsClosed.current = false;
    connectWs();
    return () => { wsClosed.current = true; try { wsRef.current?.close(); } catch (e) { /* noop */ } };
  }, [conn]);
  useEffect(() => {
    const h = () => setNarrow(window.innerWidth < 900);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  useEffect(() => {
    const iv = setInterval(() => {
      setTypingPeers(prev => {
        const now = Date.now();
        let changed = false;
        const c = {};
        for (const k in prev) { if (now - prev[k].t < 6000) c[k] = prev[k]; else changed = true; }
        return changed ? c : prev;
      });
    }, 2000);
    return () => clearInterval(iv);
  }, []);
  useEffect(() => {
    const h = e => {
      if (e.key !== 'Escape') return;
      if (ctxMenu) setCtxMenu(null);
      else if (selectMode) { setSelectMode(false); setSelected(new Set()); }
      else if (chatSearch) setChatSearch(null);
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [ctxMenu, selectMode, chatSearch]);
  useEffect(() => { if (!toast) return undefined; const t = setTimeout(() => setToast(null), 2200); return () => clearTimeout(t); }, [toast]);

  useLayoutEffect(() => {
    const el = listRef.current;
    if (!el) return;
    if (scrollMode.current === 'bottom') {
      el.scrollTop = el.scrollHeight;
      atBottomRef.current = true;
    } else if (scrollMode.current === 'restore') {
      el.scrollTop = el.scrollHeight - prevScroll.current.h + prevScroll.current.top;
    } else if (scrollMode.current === 'jump' && jumpTarget.current != null) {
      const t = el.querySelector(`[data-mid="${jumpTarget.current}"]`);
      if (t) { t.scrollIntoView({ block: 'center' }); flash(jumpTarget.current); }
      jumpTarget.current = null;
    }
    scrollMode.current = null;
  }, [msgs]);

  /* ── websocket ── */
  function connectWs() {
    try {
      const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
      const ws = new WebSocket(`${proto}://${window.location.host}/ws`);
      ws.onopen = () => setWsReady(true);
      ws.onclose = () => { setWsReady(false); if (!wsClosed.current) setTimeout(() => { if (!wsClosed.current) connectWs(); }, 3000); };
      ws.onerror = () => {};
      ws.onmessage = ev => { try { onWsRef.current(JSON.parse(ev.data)); } catch (e) { /* noop */ } };
      wsRef.current = ws;
    } catch (e) { /* noop */ }
  }

  function onWs(data) {
    const cur = selRef.current;
    if (data.type === 'new_message') {
      const { peerId, message } = data;
      if (cur?.id === peerId) {
        const stick = atBottomRef.current;
        setMsgs(prev => {
          if (prev.some(m => m.id === message.id)) return prev.map(m => m.id === message.id ? { ...m, ...message, replyTo: message.replyTo || m.replyTo } : m);
          if (message.out) {
            const tmp = prev.findIndex(m => m._pending && m.text === message.text);
            if (tmp >= 0) { const c = [...prev]; c[tmp] = { ...message, replyTo: message.replyTo || prev[tmp].replyTo }; return c; }
          }
          if (stick || message.out) scrollMode.current = 'bottom';
          return [...prev, message];
        });
        if (!stick && !message.out) setNewCount(n => n + 1);
        if (!message.out && document.visibilityState === 'visible') api.post(`/tg-client/messages/${peerId}/read`, { maxId: message.id }).catch(() => {});
        if (message.fromId) setTypingPeers(p => { if (!p[peerId]) return p; const c = { ...p }; delete c[peerId]; return c; });
      }
      setDls(prev => {
        const idx = prev.findIndex(d => d.id === peerId);
        if (idx === -1) { fetchDls(); return prev; }
        const d = { ...prev[idx] };
        d.lastMsgText = message.service || message.text || mediaLabel(message.mediaType);
        d.lastMsgDate = message.date;
        d.lastMsgOut = message.out;
        d.lastMsgId = message.id;
        d.lastMsgFrom = message.out ? null : (message.fromName || null);
        if (!message.out && cur?.id !== peerId) d.unreadCount = (d.unreadCount || 0) + 1;
        const c = [...prev];
        c.splice(idx, 1);
        const pinnedCount = c.filter(x => x.pinned).length;
        c.splice(d.pinned ? 0 : pinnedCount, 0, d);
        return c;
      });
    } else if (data.type === 'edit_message') {
      if (cur?.id === data.peerId) setMsgs(prev => prev.map(m => m.id === data.message.id ? { ...m, ...data.message, replyTo: data.message.replyTo || m.replyTo } : m));
    } else if (data.type === 'delete_messages') {
      if (!cur) return;
      const ids = new Set(data.ids || []);
      if (data.peerId ? data.peerId === cur.id : !cur.isChannel) setMsgs(prev => prev.filter(m => !ids.has(m.id)));
    } else if (data.type === 'user_status') {
      const { userId, online, lastSeen: ls } = data;
      setDls(prev => prev.map(d => d.id === userId ? { ...d, online, status: ls } : d));
      if (cur?.id === userId) setPeer(p => p ? { ...p, online, status: ls } : p);
    } else if (data.type === 'typing') {
      const pid = data.peerId;
      if (!pid) return;
      if (me && String(data.userId) === String(me.id)) return;
      setTypingPeers(prev => ({ ...prev, [pid]: { t: Date.now(), name: data.fromName || null } }));
    } else if (data.type === 'read_outbox') {
      const { peerId, maxId } = data;
      if (cur?.id === peerId) setReadMax(m => Math.max(m, maxId));
      setDls(prev => prev.map(d => d.id === peerId ? { ...d, readOutboxMaxId: Math.max(d.readOutboxMaxId || 0, maxId) } : d));
    } else if (data.type === 'pinned_update') {
      if (cur?.id === data.peerId) api.get(`/tg-client/pinned/${data.peerId}`).then(r => setPinnedMsg(r.data)).catch(() => setPinnedMsg(null));
    }
  }

  onWsRef.current = onWs;

  /* ── data ── */
  async function load() {
    setInit(true);
    try {
      const r = await api.get('/tg-client/status');
      setConn(r.data.connected);
      if (r.data.connected) { setMe(r.data.me); fetchDls(); }
    } catch (e) { /* noop */ }
    setInit(false);
  }
  async function fetchDls(archived) {
    const arch = archived !== undefined ? archived : showArchived;
    setDlLoading(true);
    try { const r = await api.get('/tg-client/dialogs', { params: { limit: 150, archived: arch } }); setDls(r.data); } catch (e) { /* noop */ }
    setDlLoading(false);
  }
  function toggleArchiveView(v) {
    const next = v !== undefined ? v : !showArchived;
    setShowArchived(next);
    setDls([]);
    fetchDls(next);
  }
  async function pinChat(d) {
    try { await api.post(`/tg-client/dialogs/${d.id}/pin`, { pinned: !d.pinned }); fetchDls(); } catch (ex) { setToast('Hata: ' + ex.message); }
  }
  async function archiveChat(d) {
    try {
      await api.post(`/tg-client/dialogs/${d.id}/archive`, { archived: !showArchived });
      setDls(p => p.filter(x => x.id !== d.id));
      setToast(showArchived ? 'Arşivden çıkarıldı' : 'Sohbet arşivlendi');
    } catch (ex) { setToast('Hata: ' + ex.message); }
  }

  function openChat(d) {
    reqId.current++;
    loadingRef.current = false;
    setSel(d); setMsgs([]); setHasMore(true); setPeer(null);
    setReplyTo(null); setEditM(null); setTxt('');
    setPinnedMsg(null); setSelectMode(false); setSelected(new Set());
    setPanelItems([]); setChatSearch(null); setCtxMenu(null);
    setNewCount(0); setShowFab(false); setReadMax(d.readOutboxMaxId || 0);
    setEmojiOpen(false); setAttachMenu(false);
    fetchMsgs(d.id, 'fresh');
    api.get(`/tg-client/entity/${d.id}`).then(r => { if (selRef.current?.id === d.id) setPeer(r.data); }).catch(() => {});
    api.get(`/tg-client/pinned/${d.id}`).then(r => { if (selRef.current?.id === d.id) setPinnedMsg(r.data); }).catch(() => {});
    api.post(`/tg-client/messages/${d.id}/read`, { maxId: 0 }).catch(() => {});
    setDls(p => p.map(x => x.id === d.id ? { ...x, unreadCount: 0, unreadMentions: 0 } : x));
    if (d.isUser && !d.bot) api.get(`/tg-client/block/${d.id}`).then(r => { if (selRef.current?.id === d.id) setPeerBlocked(!!r.data.blocked); }).catch(() => setPeerBlocked(false));
    else setPeerBlocked(false);
    if (panel) loadPanel(panelTab, d);
    setTimeout(() => txRef.current?.focus(), 80);
  }

  async function fetchMsgs(pid, mode = 'fresh', offsetId = 0, jumpId = null) {
    if (mode === 'older' && loadingRef.current) return;
    loadingRef.current = true;
    const my = reqId.current;
    setMsgLoading(true);
    try {
      const r = await api.get(`/tg-client/messages/${pid}`, { params: { limit: 40, offsetId } });
      if (my !== reqId.current) return;
      const list = [...r.data].reverse();
      if (mode === 'older') {
        const el = listRef.current;
        if (el) prevScroll.current = { h: el.scrollHeight, top: el.scrollTop };
        scrollMode.current = 'restore';
        setMsgs(p => { const ids = new Set(p.map(m => m.id)); return [...list.filter(m => !ids.has(m.id)), ...p]; });
      } else {
        if (jumpId) { scrollMode.current = 'jump'; jumpTarget.current = jumpId; } else scrollMode.current = 'bottom';
        setMsgs(list);
      }
      setHasMore(r.data.length >= 40);
    } catch (e) {
      if (my === reqId.current) setToast('Mesajlar yüklenemedi');
    } finally {
      if (my === reqId.current) { loadingRef.current = false; setMsgLoading(false); }
    }
  }

  function flash(id) {
    setFlashId(id);
    setTimeout(() => setFlashId(f => (f === id ? null : f)), 1900);
  }
  function jumpTo(id) {
    const el = listRef.current?.querySelector(`[data-mid="${id}"]`);
    if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); flash(id); return; }
    if (!sel) return;
    reqId.current++;
    fetchMsgs(sel.id, 'jump', id + 1, id);
    setShowFab(true);
  }
  function goBottom() {
    const el = listRef.current;
    if (!el || !sel) return;
    const lastLoaded = msgs[msgs.length - 1];
    const d = dls.find(x => x.id === sel.id);
    if (d && lastLoaded && d.lastMsgId && lastLoaded.id < d.lastMsgId) { reqId.current++; fetchMsgs(sel.id, 'fresh'); }
    else el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
    setNewCount(0);
  }
  function onScroll(e) {
    const el = e.currentTarget;
    const dist = el.scrollHeight - el.scrollTop - el.clientHeight;
    atBottomRef.current = dist < 120;
    setShowFab(dist > 400);
    if (dist < 120 && newCount) setNewCount(0);
    if (el.scrollTop < 400 && hasMore && !loadingRef.current && sel && msgs.length) {
      const oldest = msgs.find(m => typeof m.id === 'number');
      if (oldest) fetchMsgs(sel.id, 'older', oldest.id);
    }
  }

  /* ── sending ── */
  async function send() {
    const t = txt.trim();
    if (!sel || (!t && !editM)) return;
    if (editM) {
      if (!t) return;
      setSending(true);
      try {
        await api.put(`/tg-client/messages/${sel.id}/${editM.id}`, { text: t });
        setMsgs(p => p.map(m => m.id === editM.id ? { ...m, text: t, entities: [], editDate: Math.floor(Date.now() / 1000) } : m));
        setEditM(null); setTxt('');
      } catch (ex) { setToast('Düzenlenemedi: ' + (ex.response?.data?.error || ex.message)); }
      setSending(false);
      resetTx();
      return;
    }
    const tmpId = 'tmp_' + Date.now();
    const rp = replyTo ? previewOfMsg(replyTo) : null;
    const tmp = { id: tmpId, text: t, out: true, date: Math.floor(Date.now() / 1000), _pending: true, replyToMsgId: replyTo?.id || null, replyTo: rp, entities: [] };
    scrollMode.current = 'bottom';
    setMsgs(p => [...p, tmp]);
    setTxt(''); setReplyTo(null); resetTx();
    try {
      const r = await api.post(`/tg-client/messages/${sel.id}/send`, { text: t, replyToMsgId: tmp.replyToMsgId });
      const real = { ...r.data, replyTo: r.data.replyTo || rp };
      setMsgs(p => {
        const without = p.filter(m => m.id !== tmpId);
        if (without.some(m => m.id === real.id)) return without.map(m => m.id === real.id ? { ...m, replyTo: m.replyTo || rp } : m);
        return [...without, real];
      });
      setDls(p => {
        const idx = p.findIndex(d => d.id === sel.id);
        if (idx === -1) return p;
        const c = [...p];
        const d = { ...c[idx], lastMsgText: t, lastMsgDate: real.date, lastMsgOut: true, lastMsgId: real.id, lastMsgFrom: null };
        c.splice(idx, 1);
        c.splice(d.pinned ? 0 : c.filter(x => x.pinned).length, 0, d);
        return c;
      });
    } catch (ex) {
      setMsgs(p => p.map(m => m.id === tmpId ? { ...m, _pending: false, _failed: true } : m));
      setToast('Gönderilemedi: ' + (ex.response?.data?.error || ex.message));
    }
  }
  function resetTx() { if (txRef.current) txRef.current.style.height = '22px'; }

  function pickFile(f) {
    if (!f || !sel) return;
    const kind = f.type.startsWith('image/') ? 'image' : f.type.startsWith('video/') ? 'video' : 'file';
    setPendingFile({ file: f, kind, url: kind !== 'file' ? URL.createObjectURL(f) : null, caption: txt });
  }
  function closePending() {
    if (pendingFile?.url) URL.revokeObjectURL(pendingFile.url);
    setPendingFile(null);
  }
  async function sendPending() {
    if (!pendingFile || !sel) return;
    const fd = new FormData();
    fd.append('file', pendingFile.file);
    if (pendingFile.caption?.trim()) fd.append('caption', pendingFile.caption.trim());
    if (replyTo?.id) fd.append('replyToMsgId', replyTo.id);
    const pf = pendingFile;
    setPendingFile(null);
    setSending(true);
    setToast('Gönderiliyor…');
    try {
      const r = await api.post(`/tg-client/messages/${sel.id}/send-file`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      scrollMode.current = 'bottom';
      setMsgs(p => p.some(m => m.id === r.data.id) ? p : [...p, r.data]);
      setTxt(''); setReplyTo(null); resetTx();
      setToast(null);
    } catch (ex) { setToast('Gönderilemedi: ' + (ex.response?.data?.error || ex.message)); }
    if (pf.url) URL.revokeObjectURL(pf.url);
    setSending(false);
  }

  function onInput(e) {
    setTxt(e.target.value);
    e.target.style.height = 'auto';
    e.target.style.height = Math.min(e.target.scrollHeight, 180) + 'px';
    if (sel && Date.now() - typingSent.current > 4500) {
      typingSent.current = Date.now();
      api.post(`/tg-client/messages/${sel.id}/typing`).catch(() => {});
    }
  }
  function onKey(e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); return; }
    if (e.key === 'Escape') { setReplyTo(null); setEditM(null); if (editM) setTxt(''); return; }
    if (e.key === 'ArrowUp' && !txt) {
      const lastOut = [...msgs].reverse().find(m => m.out && !m.service && typeof m.id === 'number' && (m.text || !m.mediaType));
      if (lastOut) { e.preventDefault(); startEdit(lastOut); }
    }
  }
  function onPaste(e) {
    const f = e.clipboardData?.files?.[0];
    if (f) { e.preventDefault(); pickFile(f); }
  }
  function startEdit(m) {
    setEditM(m); setReplyTo(null); setTxt(m.text || '');
    setTimeout(() => { const t = txRef.current; if (t) { t.focus(); t.style.height = 'auto'; t.style.height = Math.min(t.scrollHeight, 180) + 'px'; } }, 0);
  }
  function startReply(m) { setReplyTo(m); setEditM(null); setTimeout(() => txRef.current?.focus(), 0); }

  /* ── message actions ── */
  function askDelete(list) {
    const ids = list.map(m => m.id).filter(id => typeof id === 'number');
    if (!ids.length) { setMsgs(p => p.filter(m => !list.includes(m))); return; }
    const many = ids.length > 1;
    const isDM = !!sel.isUser;
    const basicGroup = sel.isGroup && !sel.isChannel;
    const allMine = list.every(m => m.out);
    let check = null, text;
    if (isDM) {
      check = { label: `${firstName(sel.name)} için de sil`, value: true };
      text = many ? 'Bu mesajları silmek istediğinize emin misiniz?' : 'Bu mesajı silmek istediğinize emin misiniz?';
    } else if (basicGroup && allMine) {
      check = { label: 'Herkes için sil', value: true };
      text = many ? 'Bu mesajları silmek istediğinize emin misiniz?' : 'Bu mesajı silmek istediğinize emin misiniz?';
    } else {
      text = (many ? 'Bu mesajlar' : 'Bu mesaj') + ' sohbetteki herkes için silinecek.';
    }
    setConfirm({
      title: many ? `${ids.length} mesajı sil` : 'Mesajı sil',
      text, check, ok: 'Sil',
      onOk: async (checked) => {
        const revoke = check ? !!checked : true;
        try {
          await api.delete(`/tg-client/messages/${sel.id}`, { data: { msgIds: ids, revoke } });
          const st = new Set(ids);
          setMsgs(p => p.filter(m => !st.has(m.id)));
          setSelected(new Set()); setSelectMode(false);
          setToast(revoke ? (many ? 'Mesajlar herkes için silindi' : 'Mesaj herkes için silindi') : (many ? 'Mesajlar sizin için silindi' : 'Mesaj sizin için silindi'));
        } catch (ex) { setToast('Silinemedi: ' + (ex.response?.data?.error || ex.message)); }
      },
    });
  }

  /* ── chat-level: clear history / delete / leave ── */
  function chatKind(d) { return d.isUser ? 'user' : (d.isChannel && !d.isGroup) ? 'channel' : 'group'; }
  function askClearHistory(d) {
    const k = chatKind(d);
    setConfirm({
      title: 'Geçmişi temizle',
      text: k === 'user' ? `${d.name} ile olan tüm mesajlar silinecek. Bu işlem geri alınamaz.` : 'Bu sohbetteki mesaj geçmişi sizin için temizlenecek.',
      check: k === 'user' ? { label: `${firstName(d.name)} için de temizle`, value: false } : null,
      ok: 'Temizle',
      onOk: async (checked) => {
        try {
          await api.post(`/tg-client/dialogs/${d.id}/clear`, { revoke: !!checked });
          if (selRef.current?.id === d.id) { setMsgs([]); setHasMore(false); }
          setDls(p => p.map(x => x.id === d.id ? { ...x, lastMsgText: '', unreadCount: 0 } : x));
          setToast('Geçmiş temizlendi');
        } catch (ex) { setToast('Temizlenemedi: ' + (ex.response?.data?.error || ex.message)); }
      },
    });
  }
  function askDeleteChat(d) {
    const k = chatKind(d);
    setConfirm({
      title: k === 'user' ? 'Sohbeti sil' : k === 'channel' ? 'Kanaldan ayrıl' : 'Gruptan ayrıl',
      text: k === 'user' ? `${d.name} ile olan sohbet silinecek. Bu işlem geri alınamaz.` : `"${d.name}" ${k === 'channel' ? 'kanalından' : 'grubundan'} ayrılmak istediğinize emin misiniz?`,
      check: k === 'user' ? { label: `${firstName(d.name)} için de sil`, value: false } : null,
      ok: k === 'user' ? 'Sil' : 'Ayrıl',
      onOk: async (checked) => {
        try {
          await api.post(`/tg-client/dialogs/${d.id}/delete`, { revoke: !!checked });
          setDls(p => p.filter(x => x.id !== d.id));
          if (selRef.current?.id === d.id) { setSel(null); setMsgs([]); setPanel(false); }
          setToast(k === 'user' ? 'Sohbet silindi' : 'Ayrıldınız');
        } catch (ex) { setToast('İşlem başarısız: ' + (ex.response?.data?.error || ex.message)); }
      },
    });
  }
  function toggleSelect(id, force) {
    setSelectMode(true);
    setSelected(prev => {
      const n = new Set(prev);
      const on = force !== undefined ? force : !n.has(id);
      if (on) n.add(id); else n.delete(id);
      return n;
    });
  }
  async function togglePinMsg(m) {
    try {
      await api.post(`/tg-client/messages/${sel.id}/${m.id}/pin`, { unpin: !!m.pinned });
      setMsgs(p => p.map(x => x.id === m.id ? { ...x, pinned: !m.pinned } : x));
      const r = await api.get(`/tg-client/pinned/${sel.id}`);
      setPinnedMsg(r.data);
      setToast(m.pinned ? 'Sabitleme kaldırıldı' : 'Mesaj sabitlendi');
    } catch (ex) { setToast('Hata: ' + ex.message); }
  }
  async function doForward(toId) {
    if (!fwd || !sel) return;
    const from = fwd.from || sel.id;
    const list = fwd.msgs;
    setFwd(null); setFwdQ('');
    try {
      for (const m of list) await api.post(`/tg-client/messages/${from}/${m.id}/forward`, { toPeerId: toId });
      setToast(list.length > 1 ? `${list.length} mesaj iletildi` : 'Mesaj iletildi');
      setSelectMode(false); setSelected(new Set());
    } catch (ex) { setToast('İletilemedi: ' + ex.message); }
  }
  function copyText(list) {
    const t = list.map(m => m.text).filter(Boolean).join('\n\n');
    if (t) navigator.clipboard?.writeText(t).then(() => setToast('Metin kopyalandı')).catch(() => {});
  }
  function openMenu(e, list) {
    const W = 220, H = 330;
    setCtxMenu({ x: Math.min(e.clientX, window.innerWidth - W - 8), y: Math.min(e.clientY, window.innerHeight - H - 8), list });
  }

  /* ── viewer ── */
  function viewerItems() {
    const out = [];
    for (const m of msgs) {
      if (!VISUAL[m.mediaType] || typeof m.id !== 'number') continue;
      out.push({
        id: m.id, kind: m.mediaType, fromId: m.out ? me?.id : m.fromId, fromName: m.out ? [me?.firstName, me?.lastName].filter(Boolean).join(' ') : (m.fromName || sel?.name || ''),
        date: m.date, caption: m.text, src: mUrl(sel.id, m.id), dl: mUrl(sel.id, m.id, '&dl=1&name=' + encodeURIComponent(`telegram_${m.id}.${m.mediaType === 'photo' ? 'jpg' : 'mp4'}`)),
      });
    }
    return out;
  }
  function openViewer(m) {
    if (!sel) return;
    const items = viewerItems();
    const index = Math.max(0, items.findIndex(x => x.id === m.id));
    setViewer({ items, index });
  }

  /* ── right panel ── */
  async function loadPanel(tab, d = sel) {
    if (!d) return;
    setPanelTab(tab);
    setPanelLoading(true);
    setPanelItems([]);
    try {
      const r = tab === 'posts' ? await api.get(`/tg-client/posts/${d.id}`) : await api.get(`/tg-client/gallery/${d.id}`, { params: { filter: tab } });
      if (selRef.current?.id === d.id) setPanelItems(r.data || []);
    } catch (e) { setPanelItems([]); }
    setPanelLoading(false);
  }
  function togglePanel() {
    const next = !panel;
    setPanel(next);
    if (next) loadPanel(panelTab);
  }
  async function toggleBlock() {
    if (!sel) return;
    try {
      await api.post(`/tg-client/block/${sel.id}`, { unblock: peerBlocked });
      setPeerBlocked(!peerBlocked);
      setToast(peerBlocked ? 'Engel kaldırıldı' : 'Kullanıcı engellendi');
    } catch (ex) { setToast('Hata: ' + ex.message); }
  }

  /* ── search ── */
  function onSidebarSearch(q) {
    setDlSrch(q);
    clearTimeout(gTimer.current);
    if (q.trim().length < 2) { setGRes([]); setGSearching(false); return; }
    setGSearching(true);
    gTimer.current = setTimeout(async () => {
      try { const r = await api.get('/tg-client/search', { params: { q: q.trim() } }); setGRes(r.data || []); } catch (e) { setGRes([]); }
      setGSearching(false);
    }, 450);
  }
  function openSearchResult(item) {
    let d = dls.find(x => x.id === item.id);
    if (!d) {
      d = { id: item.id, name: item.name, username: item.username, isUser: item.type === 'user', isGroup: item.type === 'group', isChannel: item.type === 'channel', unreadCount: 0, lastMsgText: '', lastMsgDate: null, lastMsgOut: false, verified: item.verified, bot: item.bot };
      setDls(p => [d, ...p]);
    }
    setDlSrch(''); setGRes([]);
    openChat(d);
  }
  function onChatSearch(q) {
    setChatSearch(s => ({ ...(s || {}), q, loading: q.trim().length > 0 }));
    clearTimeout(csTimer.current);
    if (!q.trim() || !sel) { setChatSearch(s => ({ ...(s || {}), q, res: [], loading: false })); return; }
    const pid = sel.id;
    csTimer.current = setTimeout(async () => {
      try {
        const r = await api.get(`/tg-client/search/${pid}`, { params: { q: q.trim(), limit: 30 } });
        setChatSearch(s => (s ? { ...s, res: r.data || [], loading: false } : s));
      } catch (e) { setChatSearch(s => (s ? { ...s, res: [], loading: false } : s)); }
    }, 400);
  }

  /* ── derived ── */
  const isGroup = !!sel?.isGroup;
  const isBroadcast = !!(sel && sel.isChannel && !sel.isGroup);
  const byId = useMemo(() => new Map(msgs.map(m => [m.id, m])), [msgs]);
  function previewOfMsg(m) {
    if (!m) return null;
    return { id: m.id, fromId: m.fromId, out: m.out, fromName: m.out ? (me?.firstName || 'Siz') : (m.fromName || m.postAuthor || sel?.name || null), text: (m.text || '').slice(0, 160) || m.service || mediaLabel(m.mediaType), mediaType: m.mediaType, thumb: m.thumb || null };
  }
  const previewOf = id => { const m = byId.get(id); return m ? previewOfMsg(m) : null; };

  const sections = useMemo(() => {
    const items = [];
    for (const m of msgs) {
      const prev = items[items.length - 1];
      if (m.groupedId && VISUAL[m.mediaType] && prev && prev.type === 'album' && prev.groupedId === m.groupedId) { prev.items.push(m); continue; }
      if (m.groupedId && VISUAL[m.mediaType]) { items.push({ type: 'album', groupedId: m.groupedId, id: 'g' + m.groupedId, items: [m], date: m.date }); continue; }
      items.push(m);
    }
    const norm = items.map(it => (it.type === 'album' && it.items.length === 1 ? it.items[0] : it));
    const out = [];
    let curSec = null;
    for (const it of norm) {
      const m = it.type === 'album' ? it.items[it.items.length - 1] : it;
      const day = new Date((it.date || m.date) * 1000).toDateString();
      if (!curSec || curSec.day !== day) { curSec = { day, unix: it.date || m.date, items: [] }; out.push(curSec); }
      curSec.items.push(it);
    }
    return out;
  }, [msgs]);

  const senderKey = it => { const m = it.type === 'album' ? it.items[0] : it; return m.out ? 'me' : (m.fromId || 'peer'); };
  const sameRun = (a, b) => {
    if (!a || !b || isBroadcast) return false;
    const ma = a.type === 'album' ? a.items[a.items.length - 1] : a;
    const mb = b.type === 'album' ? b.items[0] : b;
    if (ma.service || mb.service) return false;
    return senderKey(a) === senderKey(b) && Math.abs((mb.date || 0) - (ma.date || 0)) < 600;
  };

  const ctx = {
    cid: sel?.id, isGroup, isBroadcast, isChannel: !!sel?.isChannel, readMax, selectMode, selected, flashId,
    previewOf, jumpTo, openViewer, toggleSelect, openMenu,
    onSender: (id, name) => setSenderProfile({ id, name }),
  };

  const counts = useMemo(() => {
    const c = { all: 0, users: 0, groups: 0, channels: 0, bots: 0, unread: 0 };
    for (const d of dls) {
      if (!(d.unreadCount > 0) || d.muted) continue;
      c.all++;
      if (d.isUser && !d.bot) c.users++;
      if (d.isGroup) c.groups++;
      if (d.isChannel && !d.isGroup) c.channels++;
      if (d.bot) c.bots++;
      c.unread++;
    }
    return c;
  }, [dls]);
  const filtered = dls.filter(d => {
    if (dlSrch && !(d.name || '').toLocaleLowerCase('tr').includes(dlSrch.toLocaleLowerCase('tr')) && !(d.username || '').toLowerCase().includes(dlSrch.toLowerCase())) return false;
    if (dlFlt === 'users') return d.isUser && !d.bot;
    if (dlFlt === 'groups') return d.isGroup;
    if (dlFlt === 'channels') return d.isChannel && !d.isGroup;
    if (dlFlt === 'bots') return d.bot;
    if (dlFlt === 'unread') return d.unreadCount > 0 || d.unreadMentions > 0;
    return true;
  });

  const typingNow = sel && typingPeers[sel.id];
  const ls = lastSeen(peer || sel);
  let statusLine = '', statusAccent = false;
  if (sel) {
    if (typingNow) { statusLine = (isGroup && typingNow.name ? firstName(typingNow.name) + ' ' : '') + 'yazıyor'; statusAccent = true; }
    else if (sel.bot) statusLine = 'bot';
    else if (sel.isUser) { statusLine = ls ? ls.t : ''; statusAccent = !!ls?.on; }
    else if (isGroup) statusLine = peer?.membersCount ? peer.membersCount.toLocaleString('tr-TR') + ' üye' : 'grup';
    else if (isBroadcast) statusLine = peer?.membersCount ? peer.membersCount.toLocaleString('tr-TR') + ' abone' : 'kanal';
  }
  const showSidebar = !narrow || !sel;
  const showChat = !narrow || !!sel;
  const selD = sel ? (dls.find(d => d.id === sel.id) || sel) : null;

  if (!pwOk) return <PwScreen onOk={() => setPwOk(true)} />;
  if (init) return <div className="tgc" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 'var(--tg-h, calc(100vh - 48px))', background: T.bg, borderRadius: 'var(--tg-radius, 12px)' }}><style>{CSS}</style><div className="tgc-spin" /></div>;
  if (!conn) return <LoginScreen onLogin={m => { setConn(true); setMe(m); fetchDls(); }} />;

  const meName = [me?.firstName, me?.lastName].filter(Boolean).join(' ');

  /* ════════════════════════ RENDER ════════════════════════ */
  return (
    <div className="tgc" style={{ display: 'flex', background: T.bg, overflow: 'hidden', height: 'var(--tg-h, calc(100vh - 48px))', borderRadius: 'var(--tg-radius, 12px)', position: 'relative' }}
      onClick={() => { if (mainMenu) setMainMenu(false); if (attachMenu) setAttachMenu(false); if (emojiOpen) setEmojiOpen(false); if (headMenu) setHeadMenu(false); }}>
      <style>{CSS}</style>

      {/* ═════════ SIDEBAR ═════════ */}
      {showSidebar && (
        <div style={{ width: narrow ? '100%' : 340, minWidth: narrow ? 0 : 300, display: 'flex', flexDirection: 'column', background: T.side, borderRight: `1px solid ${T.line}`, position: 'relative' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 10px 6px' }}>
            {showArchived ? (
              <>
                <button className="tgc-btn" onClick={() => toggleArchiveView(false)} title="Geri"><Ic n="back" /></button>
                <div style={{ flex: 1, fontSize: 17, fontWeight: 600, paddingLeft: 4 }}>Arşiv</div>
              </>
            ) : (
              <>
                <div style={{ position: 'relative' }}>
                  <button className="tgc-btn" onClick={e => { e.stopPropagation(); setMainMenu(v => !v); }} title="Menü"><Ic n="menu" /></button>
                  {mainMenu && (
                    <div className="tgc-fade" onClick={e => e.stopPropagation()} style={{ position: 'absolute', top: 44, left: 0, zIndex: 50, background: T.menu, borderRadius: 10, padding: 6, minWidth: 230, boxShadow: '0 8px 30px rgba(0,0,0,.5)' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px 10px', borderBottom: `1px solid ${T.line}`, marginBottom: 4 }}>
                        <Avatar id={me?.id} name={meName || '?'} size={40} />
                        <div style={{ minWidth: 0 }}>
                          <div style={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{meName}</div>
                          <div style={{ fontSize: 13, color: T.sub }}>{me?.username ? '@' + me.username : me?.phone}</div>
                        </div>
                      </div>
                      <button className="tgc-mi" onClick={() => { setMainMenu(false); setMeModal(true); setMeEd(false); setMeForm({ firstName: me?.firstName || '', lastName: me?.lastName || '', bio: '' }); }}><Ic n="user" s={20} c={T.dim} />Profilim</button>
                      <button className="tgc-mi" onClick={() => { setMainMenu(false); toggleArchiveView(true); }}><Ic n="archive" s={20} c={T.dim} />Arşivlenmiş sohbetler</button>
                      <button className="tgc-mi danger" onClick={() => { setMainMenu(false); setConfirm({ title: 'Çıkış yapılsın mı?', text: 'Telegram oturumu bu panelden kapatılacak.', ok: 'Çıkış', onOk: async () => { await api.post('/tg-client/logout').catch(() => {}); setConn(false); setDls([]); setSel(null); } }); }}><Ic n="logout" s={20} c={T.danger} />Çıkış yap</button>
                    </div>
                  )}
                </div>
                <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8, background: T.input, borderRadius: 22, padding: '0 12px', height: 40 }}>
                  <Ic n="search" s={18} c={T.dim} />
                  <input value={dlSrch} onChange={e => onSidebarSearch(e.target.value)} placeholder="Ara"
                    style={{ flex: 1, background: 'none', border: 'none', outline: 'none', color: T.text, fontSize: 14.5, fontFamily: 'inherit', minWidth: 0 }} />
                  {dlSrch && <button className="tgc-btn" style={{ padding: 2 }} onClick={() => onSidebarSearch('')}><Ic n="close" s={16} /></button>}
                </div>
              </>
            )}
          </div>
          {!wsReady && <div style={{ padding: '0 18px 6px', fontSize: 12.5, color: T.sub }}>Bağlanıyor…</div>}

          {!dlSrch && !showArchived && (
            <div style={{ display: 'flex', overflowX: 'auto', borderBottom: `1px solid ${T.line}`, padding: '0 6px', scrollbarWidth: 'none' }}>
              {[['all', 'Tümü'], ['users', 'Kişiler'], ['groups', 'Gruplar'], ['channels', 'Kanallar'], ['bots', 'Botlar'], ['unread', 'Okunmamış']].map(([v, l]) => (
                <button key={v} className={'tgc-tab' + (dlFlt === v ? ' on' : '')} onClick={() => setDlFlt(v)}>
                  {l}
                  {counts[v] > 0 && v !== 'unread' && <span style={{ background: dlFlt === v ? T.link : T.badgeMuted, color: dlFlt === v ? T.side : '#fff', fontSize: 11, fontWeight: 700, borderRadius: 9, padding: '0 6px', minWidth: 18, lineHeight: '18px', textAlign: 'center' }}>{counts[v]}</span>}
                </button>
              ))}
            </div>
          )}

          <div style={{ flex: 1, overflowY: 'auto', padding: '4px 0' }}>
            {!dlSrch && !showArchived && dlFlt === 'all' && (
              <div className="tgc-row" onClick={() => toggleArchiveView(true)} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '7px 10px', margin: '0 6px', borderRadius: 10, cursor: 'pointer' }}>
                <div style={{ width: 54, height: 54, borderRadius: '50%', background: '#3d4a59', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#c6d0da', flexShrink: 0 }}><Ic n="archive" s={24} /></div>
                <div style={{ fontWeight: 600, fontSize: 15 }}>Arşivlenmiş sohbetler</div>
              </div>
            )}
            {dlSrch && <div style={{ padding: '8px 18px 4px', fontSize: 13.5, color: T.sub, fontWeight: 600 }}>Sohbetler</div>}

            {filtered.map(d => {
              const active = sel?.id === d.id;
              const ty = typingPeers[d.id];
              const groupLike = d.isGroup;
              const read = d.lastMsgOut && d.lastMsgId && d.readOutboxMaxId >= d.lastMsgId;
              const prefix = d.lastMsgOut && groupLike ? 'Siz' : (groupLike && d.lastMsgFrom ? firstName(d.lastMsgFrom) : null);
              return (
                <div key={d.id} className={'tgc-row' + (active ? ' act' : '')} onClick={() => openChat(d)}
                  onContextMenu={e => { e.preventDefault(); setDlMenu({ d, x: Math.min(e.clientX, window.innerWidth - 230), y: Math.min(e.clientY, window.innerHeight - 140) }); }}
                  style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '7px 10px', margin: '0 6px', borderRadius: 10, cursor: 'pointer' }}>
                  <Avatar id={d.id} name={d.name} size={54} online={d.isUser && d.online && !d.bot} ringColor={active ? T.act : T.side} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <div style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 4, fontWeight: 600, fontSize: 15, color: '#fff' }}>
                        {d.isChannel && !d.isGroup && <Ic n="channel" s={16} c={active ? '#fff' : T.sub} />}
                        {d.isGroup && <Ic n="group" s={16} c={active ? '#fff' : T.sub} />}
                        {d.bot && <Ic n="bot" s={16} c={active ? '#fff' : T.sub} />}
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.name}</span>
                        {d.verified && <Verified s={15} />}
                        {d.muted && <Ic n="mute" s={14} c={active ? '#cfe0f1' : T.dim} />}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 3, flexShrink: 0, fontSize: 12.5, color: active ? '#cfe0f1' : T.dim }}>
                        {d.lastMsgOut && <Checks read={read} c={active ? '#fff' : T.link} s={15} />}
                        {listTime(d.lastMsgDate)}
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2 }}>
                      <div style={{ flex: 1, minWidth: 0, fontSize: 14, color: active ? '#d9e6f2' : T.sub, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {ty ? (
                          <span style={{ color: active ? '#fff' : T.link }}>{groupLike && ty.name ? firstName(ty.name) + ' ' : ''}yazıyor<span className="tgc-dots"><span>.</span><span>.</span><span>.</span></span></span>
                        ) : (
                          <>
                            {prefix && <span style={{ color: active ? '#fff' : '#e3e9ef' }}>{prefix}: </span>}
                            {(d.lastMsgText || '').replace(/\s+/g, ' ')}
                          </>
                        )}
                      </div>
                      {d.unreadMentions > 0 && <span style={{ width: 20, height: 20, borderRadius: '50%', background: active ? '#fff' : T.accent, color: active ? T.act : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Ic n="at" s={14} sw={2.2} /></span>}
                      {d.unreadCount > 0 ? (
                        <span style={{ background: active ? '#fff' : (d.muted ? T.badgeMuted : T.accent), color: active ? T.act : '#fff', fontSize: 12, fontWeight: 600, borderRadius: 11, padding: '0 7px', minWidth: 22, height: 22, lineHeight: '22px', textAlign: 'center', flexShrink: 0 }}>
                          {d.unreadCount > 999 ? fmtCount(d.unreadCount) : d.unreadCount}
                        </span>
                      ) : d.pinned ? <Ic n="pin" s={16} c={active ? '#cfe0f1' : T.dim} /> : null}
                    </div>
                  </div>
                </div>
              );
            })}
            {!filtered.length && !dlLoading && !dlSrch && <div style={{ textAlign: 'center', padding: 30, color: T.dim, fontSize: 14 }}>{showArchived ? 'Arşivde sohbet yok' : 'Sohbet yok'}</div>}
            {dlLoading && !dls.length && <div style={{ display: 'flex', justifyContent: 'center', padding: 30 }}><div className="tgc-spin" /></div>}

            {dlSrch && (
              <>
                <div style={{ padding: '12px 18px 4px', fontSize: 13.5, color: T.sub, fontWeight: 600 }}>Genel arama</div>
                {gSearching && <div style={{ display: 'flex', justifyContent: 'center', padding: 16 }}><div className="tgc-spin" /></div>}
                {!gSearching && !gRes.length && dlSrch.trim().length >= 2 && <div style={{ padding: '6px 18px', color: T.dim, fontSize: 13.5 }}>Sonuç yok</div>}
                {gRes.filter(r => !dls.some(d => d.id === r.id)).map(r => (
                  <div key={r.id} className="tgc-row" onClick={() => openSearchResult(r)} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '7px 10px', margin: '0 6px', borderRadius: 10, cursor: 'pointer' }}>
                    <Avatar id={r.id} name={r.name} size={46} />
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4 }}>{r.name}{r.verified && <Verified s={15} />}</div>
                      <div style={{ fontSize: 13.5, color: T.sub }}>{r.username ? '@' + r.username : ''}{r.type === 'group' ? ' · grup' : r.type === 'channel' ? ' · kanal' : r.bot ? ' · bot' : ''}</div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>

          {dlMenu && (
            <div onClick={() => setDlMenu(null)} onContextMenu={e => { e.preventDefault(); setDlMenu(null); }} style={{ position: 'fixed', inset: 0, zIndex: 5999 }}>
              <div className="tgc-fade" onClick={e => e.stopPropagation()} style={{ position: 'fixed', left: dlMenu.x, top: dlMenu.y, zIndex: 6000, background: T.menu, borderRadius: 10, padding: 6, boxShadow: '0 8px 30px rgba(0,0,0,.5)', minWidth: 220 }}>
                <button className="tgc-mi" onClick={() => { pinChat(dlMenu.d); setDlMenu(null); }}><Ic n="pin" s={20} c={T.dim} />{dlMenu.d.pinned ? 'Sabitlemeyi kaldır' : 'Sohbeti sabitle'}</button>
                <button className="tgc-mi" onClick={() => { archiveChat(dlMenu.d); setDlMenu(null); }}><Ic n={showArchived ? 'unarchive' : 'archive'} s={20} c={T.dim} />{showArchived ? 'Arşivden çıkar' : 'Arşivle'}</button>
                <button className="tgc-mi" onClick={() => { api.post(`/tg-client/messages/${dlMenu.d.id}/read`, { maxId: 0 }).catch(() => {}); setDls(p => p.map(x => x.id === dlMenu.d.id ? { ...x, unreadCount: 0, unreadMentions: 0 } : x)); setDlMenu(null); }}><Ic n="check" s={20} c={T.dim} />Okundu olarak işaretle</button>
                {chatKind(dlMenu.d) !== 'channel' && <button className="tgc-mi" onClick={() => { const d = dlMenu.d; setDlMenu(null); askClearHistory(d); }}><Ic n="close" s={20} c={T.dim} />Geçmişi temizle</button>}
                <button className="tgc-mi danger" onClick={() => { const d = dlMenu.d; setDlMenu(null); askDeleteChat(d); }}><Ic n={chatKind(dlMenu.d) === 'user' ? 'trash' : 'logout'} s={20} c={T.danger} />{chatKind(dlMenu.d) === 'user' ? 'Sohbeti sil' : chatKind(dlMenu.d) === 'channel' ? 'Kanaldan ayrıl' : 'Gruptan ayrıl'}</button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ═════════ CHAT ═════════ */}
      {showChat && (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, position: 'relative' }}
          onDragEnter={e => { if (!sel || !e.dataTransfer?.types?.includes('Files')) return; e.preventDefault(); dragDepth.current++; setDragOver(true); }}
          onDragOver={e => { if (sel && e.dataTransfer?.types?.includes('Files')) e.preventDefault(); }}
          onDragLeave={() => { dragDepth.current = Math.max(0, dragDepth.current - 1); if (!dragDepth.current) setDragOver(false); }}
          onDrop={e => { e.preventDefault(); dragDepth.current = 0; setDragOver(false); const f = e.dataTransfer?.files?.[0]; if (f) pickFile(f); }}>
          {!sel ? (
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ background: 'rgba(30,44,58,.85)', color: '#e8edf2', fontSize: 14, padding: '6px 14px', borderRadius: 16 }}>Mesajlaşmak için bir sohbet seçin</span>
            </div>
          ) : (
            <>
              {/* header */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '0 8px 0 12px', height: 56, background: T.side, borderBottom: `1px solid ${T.line}`, flexShrink: 0 }}>
                {narrow && <button className="tgc-btn" onClick={() => setSel(null)}><Ic n="back" /></button>}
                <div onClick={togglePanel} style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1, minWidth: 0, cursor: 'pointer' }}>
                  <Avatar id={sel.id} name={sel.name} size={42} />
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 15.5, display: 'flex', alignItems: 'center', gap: 5 }}>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{sel.name}</span>
                      {sel.verified && <Verified />}
                      {selD?.muted && <Ic n="mute" s={14} c={T.dim} />}
                    </div>
                    <div style={{ fontSize: 13.5, color: statusAccent ? T.link : T.sub, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {statusLine}{typingNow && <span className="tgc-dots"><span>.</span><span>.</span><span>.</span></span>}
                    </div>
                  </div>
                </div>
                <button className="tgc-btn" title="Sohbette ara" onClick={() => setChatSearch(s => (s ? null : { q: '', res: [], loading: false }))} style={chatSearch ? { color: T.link } : undefined}><Ic n="search" /></button>
                <button className="tgc-btn" title={selectMode ? 'Seçimi bitir' : 'Mesaj seç'} onClick={() => { if (selectMode) { setSelectMode(false); setSelected(new Set()); } else setSelectMode(true); }} style={selectMode ? { color: T.link } : undefined}><Ic n="select" /></button>
                <button className="tgc-btn" title="Bilgi" onClick={togglePanel} style={panel ? { color: T.link } : undefined}><Ic n="info" /></button>
                <div style={{ position: 'relative' }}>
                  <button className="tgc-btn" title="Diğer" onClick={e => { e.stopPropagation(); setHeadMenu(v => !v); }}><Ic n="more" /></button>
                  {headMenu && (
                    <div className="tgc-fade" onClick={e => e.stopPropagation()} style={{ position: 'absolute', top: 44, right: 0, zIndex: 50, background: T.menu, borderRadius: 10, padding: 6, minWidth: 220, boxShadow: '0 8px 30px rgba(0,0,0,.5)' }}>
                      <button className="tgc-mi" onClick={() => { setHeadMenu(false); setSelectMode(true); }}><Ic n="select" s={20} c={T.dim} />Mesajları seç</button>
                      {chatKind(sel) !== 'channel' && <button className="tgc-mi" onClick={() => { setHeadMenu(false); askClearHistory(sel); }}><Ic n="close" s={20} c={T.dim} />Geçmişi temizle</button>}
                      <button className="tgc-mi danger" onClick={() => { setHeadMenu(false); askDeleteChat(sel); }}><Ic n={chatKind(sel) === 'user' ? 'trash' : 'logout'} s={20} c={T.danger} />{chatKind(sel) === 'user' ? 'Sohbeti sil' : chatKind(sel) === 'channel' ? 'Kanaldan ayrıl' : 'Gruptan ayrıl'}</button>
                    </div>
                  )}
                </div>
              </div>

              {/* in-chat search */}
              {chatSearch && (
                <div style={{ background: T.side, borderBottom: `1px solid ${T.line}`, padding: '6px 12px', position: 'relative', flexShrink: 0, zIndex: 20 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: T.input, borderRadius: 20, padding: '0 12px', height: 36 }}>
                    <Ic n="search" s={17} c={T.dim} />
                    <input autoFocus value={chatSearch.q} onChange={e => onChatSearch(e.target.value)} placeholder="Bu sohbette ara"
                      style={{ flex: 1, background: 'none', border: 'none', outline: 'none', color: T.text, fontSize: 14, fontFamily: 'inherit' }} />
                    {chatSearch.loading && <div className="tgc-spin" style={{ width: 16, height: 16, borderWidth: 2 }} />}
                    <button className="tgc-btn" style={{ padding: 2 }} onClick={() => setChatSearch(null)}><Ic n="close" s={16} /></button>
                  </div>
                  {chatSearch.q && (chatSearch.res || []).length > 0 && (
                    <div className="tgc-fade" style={{ position: 'absolute', left: 12, right: 12, top: 46, background: T.menu, borderRadius: 10, maxHeight: 340, overflowY: 'auto', boxShadow: '0 10px 30px rgba(0,0,0,.5)', padding: 4 }}>
                      {chatSearch.res.map(r => (
                        <div key={r.id} className="tgc-row" onClick={() => { setChatSearch(null); jumpTo(r.id); }} style={{ padding: '8px 12px', borderRadius: 8, cursor: 'pointer' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12.5, color: T.sub, marginBottom: 2 }}><span>{r.out ? 'Siz' : (sel.name)}</span><span>{listTime(r.date)}</span></div>
                          <div style={{ fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.text || '[medya]'}</div>
                        </div>
                      ))}
                    </div>
                  )}
                  {chatSearch.q && !chatSearch.loading && !(chatSearch.res || []).length && <div style={{ fontSize: 13, color: T.dim, padding: '6px 6px 0' }}>Sonuç bulunamadı</div>}
                </div>
              )}

              {/* pinned */}
              {pinnedMsg && pinnedMsg.id && (
                <div onClick={() => jumpTo(pinnedMsg.id)} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 10px 6px 14px', background: T.side, borderBottom: `1px solid ${T.line}`, cursor: 'pointer', flexShrink: 0 }}>
                  <div style={{ width: 2, alignSelf: 'stretch', background: T.link, borderRadius: 1 }} />
                  {VISUAL[pinnedMsg.mediaType] && pinnedMsg.thumb && <img src={pinnedMsg.thumb} alt="" style={{ width: 34, height: 34, borderRadius: 4, objectFit: 'cover' }} />}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13.5, color: T.link, fontWeight: 600 }}>Sabitlenmiş mesaj</div>
                    <div style={{ fontSize: 13.5, color: '#d3dce5', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{(pinnedMsg.text || mediaLabel(pinnedMsg.mediaType) || 'Mesaj').replace(/\s+/g, ' ')}</div>
                  </div>
                  <button className="tgc-btn" title="Sabitlemeyi kaldır" onClick={e => { e.stopPropagation(); togglePinMsg({ ...pinnedMsg, pinned: true }); }}><Ic n="close" s={18} /></button>
                </div>
              )}

              {/* messages */}
              <div ref={listRef} onScroll={onScroll} style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', background: T.bg, position: 'relative' }}>
                <div style={{ maxWidth: isBroadcast ? 640 : 780, margin: '0 auto', padding: `8px ${selectMode ? 18 : 14}px 10px ${selectMode ? 50 : 14}px`, minHeight: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                  {msgLoading && !msgs.length && <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}><div className="tgc-spin" /></div>}
                  {msgLoading && msgs.length > 0 && hasMore && <div style={{ display: 'flex', justifyContent: 'center', padding: 10 }}><div className="tgc-spin" style={{ width: 22, height: 22 }} /></div>}
                  {!msgLoading && !msgs.length && (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
                      <span style={{ background: 'rgba(30,44,58,.85)', color: '#e8edf2', fontSize: 14, padding: '8px 16px', borderRadius: 14 }}>Henüz mesaj yok</span>
                    </div>
                  )}
                  {sections.map(sec => (
                    <div key={sec.day}>
                      <div style={{ position: 'sticky', top: 6, zIndex: 3, display: 'flex', justifyContent: 'center', padding: '6px 0', pointerEvents: 'none' }}>
                        <span style={{ background: 'rgba(30,44,58,.9)', color: '#e8edf2', fontSize: 13, fontWeight: 500, padding: '4px 12px', borderRadius: 14 }}>{dateLabel(sec.unix)}</span>
                      </div>
                      {sec.items.map((it, i) => (
                        <MessageRow key={it.id} item={it} ctx={ctx}
                          first={!sameRun(sec.items[i - 1], it)} last={!sameRun(it, sec.items[i + 1])} />
                      ))}
                    </div>
                  ))}
                </div>
              </div>

              {showFab && (
                <button onClick={goBottom} style={{ position: 'absolute', right: 20, bottom: 80, width: 48, height: 48, borderRadius: '50%', border: 'none', background: T.side, color: T.sub, boxShadow: '0 2px 10px rgba(0,0,0,.4)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10 }}>
                  <Ic n="down" s={26} />
                  {newCount > 0 && <span style={{ position: 'absolute', top: -6, right: -2, background: T.accent, color: '#fff', fontSize: 12, fontWeight: 600, borderRadius: 11, minWidth: 22, height: 22, lineHeight: '22px', textAlign: 'center', padding: '0 6px' }}>{newCount}</span>}
                </button>
              )}

              {/* composer */}
              {selectMode ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 14px', background: T.side, borderTop: `1px solid ${T.line}`, minHeight: 56, flexShrink: 0 }}>
                  <button className="tgc-btn" onClick={() => { setSelectMode(false); setSelected(new Set()); }}><Ic n="close" /></button>
                  <div style={{ flex: 1, fontWeight: 600 }}>{selected.size ? `${selected.size} mesaj seçildi` : 'Mesaj seçin'}</div>
                  <TextBtn disabled={!selected.size} onClick={() => setFwd({ msgs: msgs.filter(m => selected.has(m.id)) })}>İlet</TextBtn>
                  <TextBtn danger disabled={!selected.size} onClick={() => askDelete(msgs.filter(m => selected.has(m.id)))}>Sil</TextBtn>
                </div>
              ) : peerBlocked && sel.isUser ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: 8, background: T.side, borderTop: `1px solid ${T.line}`, flexShrink: 0 }}>
                  <TextBtn onClick={toggleBlock}>Engeli kaldır</TextBtn>
                </div>
              ) : (
                <div style={{ background: T.side, borderTop: `1px solid ${T.line}`, flexShrink: 0, position: 'relative' }}>
                  {(replyTo || editM) && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 10px 2px 16px' }}>
                      <Ic n={editM ? 'edit' : 'reply'} s={22} c={T.link} />
                      <div style={{ flex: 1, minWidth: 0, borderLeft: `2px solid ${T.link}`, paddingLeft: 10 }}>
                        <div style={{ fontSize: 13.5, color: T.link, fontWeight: 600 }}>{editM ? 'Düzenleniyor' : (replyTo.out ? (me?.firstName || 'Siz') : (replyTo.fromName || sel.name))}</div>
                        <div style={{ fontSize: 13.5, color: '#d3dce5', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{((editM || replyTo).text || mediaLabel((editM || replyTo).mediaType) || 'Mesaj').replace(/\s+/g, ' ')}</div>
                      </div>
                      <button className="tgc-btn" onClick={() => { setReplyTo(null); if (editM) { setEditM(null); setTxt(''); } }}><Ic n="close" s={20} /></button>
                    </div>
                  )}
                  <div style={{ display: 'flex', alignItems: 'flex-end', gap: 2, padding: '7px 8px' }}>
                    <div style={{ position: 'relative' }}>
                      <button className="tgc-btn" title="Ekle" onClick={e => { e.stopPropagation(); setAttachMenu(v => !v); setEmojiOpen(false); }}><Ic n="attach" s={24} /></button>
                      {attachMenu && (
                        <div className="tgc-fade" onClick={e => e.stopPropagation()} style={{ position: 'absolute', bottom: 48, left: 0, background: T.menu, borderRadius: 10, padding: 6, minWidth: 210, boxShadow: '0 8px 30px rgba(0,0,0,.5)', zIndex: 30 }}>
                          <button className="tgc-mi" onClick={() => { setAttachMenu(false); mediaInRef.current?.click(); }}><Ic n="photo" s={20} c={T.dim} />Fotoğraf veya video</button>
                          <button className="tgc-mi" onClick={() => { setAttachMenu(false); fileInRef.current?.click(); }}><Ic n="file" s={20} c={T.dim} />Dosya</button>
                        </div>
                      )}
                    </div>
                    <input type="file" ref={mediaInRef} accept="image/*,video/*" onChange={e => { pickFile(e.target.files?.[0]); e.target.value = ''; }} style={{ display: 'none' }} />
                    <input type="file" ref={fileInRef} onChange={e => { pickFile(e.target.files?.[0]); e.target.value = ''; }} style={{ display: 'none' }} />
                    <textarea ref={txRef} value={txt} onChange={onInput} onKeyDown={onKey} onPaste={onPaste} rows={1}
                      placeholder={isBroadcast ? 'Yayınla…' : 'Mesaj yazın…'}
                      style={{ flex: 1, background: 'none', border: 'none', outline: 'none', color: T.text, fontSize: 15, lineHeight: '22px', resize: 'none', height: 22, maxHeight: 180, padding: 0, margin: '9px 6px', fontFamily: 'inherit', overflowY: 'auto' }} />
                    <div style={{ position: 'relative' }}>
                      <button className="tgc-btn" title="Emoji" onClick={e => { e.stopPropagation(); setEmojiOpen(v => !v); setAttachMenu(false); }} style={emojiOpen ? { color: T.link } : undefined}><Ic n="smile" s={24} /></button>
                      {emojiOpen && (
                        <div className="tgc-fade" onClick={e => e.stopPropagation()} style={{ position: 'absolute', bottom: 48, right: 0, background: T.menu, borderRadius: 12, padding: 8, boxShadow: '0 8px 30px rgba(0,0,0,.5)', display: 'grid', gridTemplateColumns: 'repeat(8, 38px)', gap: 2, maxHeight: 300, overflowY: 'auto', zIndex: 30 }}>
                          {EMOJIS.map(em => (
                            <button key={em} onClick={() => { setTxt(t => t + em); txRef.current?.focus(); }} style={{ background: 'none', border: 'none', fontSize: 24, width: 38, height: 38, borderRadius: 8, cursor: 'pointer', fontFamily: 'inherit' }}
                              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,.08)'; }} onMouseLeave={e => { e.currentTarget.style.background = 'none'; }}>{em}</button>
                          ))}
                        </div>
                      )}
                    </div>
                    <button className="tgc-btn" title={editM ? 'Kaydet' : 'Gönder'} onClick={send} disabled={sending || !txt.trim()} style={{ color: txt.trim() ? T.link : T.dim }}>
                      {editM ? <Ic n="check" s={26} sw={2.4} /> : <Ic n="send" s={26} />}
                    </button>
                  </div>
                </div>
              )}

              {dragOver && (
                <div style={{ position: 'absolute', inset: 10, border: `2px dashed ${T.link}`, borderRadius: 14, background: 'rgba(14,22,33,.88)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 60, pointerEvents: 'none', flexDirection: 'column', gap: 10, color: T.link }}>
                  <Ic n="file" s={46} />
                  <div style={{ fontSize: 18, fontWeight: 600 }}>Göndermek için dosyayı buraya bırakın</div>
                </div>
              )}
            </>
          )}
        </div>
      )}

      {/* ═════════ RIGHT PANEL ═════════ */}
      {sel && panel && (
        <div style={{ width: narrow ? '100%' : 360, flexShrink: 0, background: T.side, borderLeft: `1px solid ${T.line}`, display: 'flex', flexDirection: 'column', ...(narrow ? { position: 'absolute', inset: 0, zIndex: 80 } : {}) }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, height: 56, padding: '0 8px 0 16px', borderBottom: `1px solid ${T.line}`, flexShrink: 0 }}>
            <div style={{ flex: 1, fontWeight: 600, fontSize: 16 }}>{sel.isUser ? 'Kullanıcı bilgisi' : isBroadcast ? 'Kanal bilgisi' : 'Grup bilgisi'}</div>
            <button className="tgc-btn" onClick={() => setPanel(false)}><Ic n="close" /></button>
          </div>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '22px 16px 16px' }}>
              <Avatar id={sel.id} name={sel.name} size={110} big onClick={() => setViewer({ items: [{ kind: 'photo', src: mediaUrl(`/photo/${sel.id}`, '&big=1'), fromName: sel.name, fromId: sel.id }], index: 0 })} />
              <div style={{ fontSize: 19, fontWeight: 600, marginTop: 14, textAlign: 'center', display: 'flex', alignItems: 'center', gap: 6 }}>{peer?.title || [peer?.firstName, peer?.lastName].filter(Boolean).join(' ') || sel.name}{sel.verified && <Verified s={18} />}</div>
              <div style={{ fontSize: 14, color: statusAccent ? T.link : T.sub, marginTop: 3 }}>{statusLine}</div>
            </div>
            <div style={{ padding: '0 6px 8px' }}>
              {peer?.phone && <InfoRow icon="phone" value={'+' + String(peer.phone).replace(/^\+/, '')} label="Telefon" onCopy={() => { navigator.clipboard?.writeText('+' + String(peer.phone).replace(/^\+/, '')); setToast('Kopyalandı'); }} />}
              {peer?.username && <InfoRow icon="at" value={'@' + peer.username} label="Kullanıcı adı" onCopy={() => { navigator.clipboard?.writeText('https://t.me/' + peer.username); setToast('Bağlantı kopyalandı'); }} />}
              {peer?.bio && <InfoRow icon="info" value={peer.bio} label={sel.isUser ? 'Hakkında' : 'Açıklama'} multiline />}
              {sel.isUser && !sel.bot && (
                <button className="tgc-mi" onClick={toggleBlock} style={{ color: peerBlocked ? T.online : T.danger, padding: '12px 16px' }}>
                  <Ic n="block" s={22} c={peerBlocked ? T.online : T.danger} />{peerBlocked ? 'Engeli kaldır' : 'Kullanıcıyı engelle'}
                </button>
              )}
            </div>
            <div style={{ height: 8, background: T.bg }} />
            <div style={{ display: 'flex', overflowX: 'auto', borderBottom: `1px solid ${T.line}`, padding: '0 6px', position: 'sticky', top: 0, background: T.side, zIndex: 2, scrollbarWidth: 'none' }}>
              {[['photo_video', 'Medya'], ['file', 'Dosyalar'], ['link', 'Bağlantılar'], ['voice', 'Ses'], ...((sel.isUser && !sel.bot) || isBroadcast ? [['posts', 'Gönderiler']] : [])].map(([v, l]) => (
                <button key={v} className={'tgc-tab' + (panelTab === v ? ' on' : '')} onClick={() => loadPanel(v)}>{l}</button>
              ))}
            </div>
            {panelLoading && <div style={{ display: 'flex', justifyContent: 'center', padding: 30 }}><div className="tgc-spin" /></div>}
            {!panelLoading && !panelItems.length && <div style={{ textAlign: 'center', color: T.dim, padding: 30, fontSize: 14 }}>İçerik bulunamadı</div>}
            {!panelLoading && panelTab === 'photo_video' && panelItems.length > 0 && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 2, padding: 2 }}>
                {panelItems.map((m, i) => (
                  <div key={m.id} onClick={() => setViewer({ items: panelItems.map(x => ({ id: x.id, kind: x.mediaType, src: mUrl(sel.id, x.id), date: x.date, caption: x.text, fromName: x.fromName || sel.name, fromId: x.fromId })), index: i })}
                    style={{ aspectRatio: '1', position: 'relative', overflow: 'hidden', cursor: 'pointer', background: '#0f1923' }}>
                    <Blur thumb={m.thumb} />
                    <img src={mUrl(sel.id, m.id, '&size=thumb')} alt="" loading="lazy" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
                    {m.mediaType === 'video' && m.duration > 0 && <span style={{ position: 'absolute', left: 4, bottom: 4, background: 'rgba(0,0,0,.55)', color: '#fff', fontSize: 11, padding: '1px 6px', borderRadius: 8 }}>{fmtDur(m.duration)}</span>}
                  </div>
                ))}
              </div>
            )}
            {!panelLoading && (panelTab === 'file' || panelTab === 'voice') && panelItems.length > 0 && (
              <div style={{ padding: '6px 12px' }}>
                {panelItems.map(m => (
                  <div key={m.id} style={{ padding: '8px 4px', borderBottom: `1px solid ${T.line}` }}>
                    {panelTab === 'voice' ? <AudioPlayer msg={m} cid={sel.id} voice={m.mediaType === 'voice'} /> : <FileBox msg={m} cid={sel.id} />}
                    <div style={{ fontSize: 12, color: T.dim, marginTop: 4 }}>{listTime(m.date)}</div>
                  </div>
                ))}
              </div>
            )}
            {!panelLoading && panelTab === 'link' && panelItems.length > 0 && (
              <div style={{ padding: '6px 12px' }}>
                {panelItems.map(m => (
                  <div key={m.id} onClick={() => { jumpTo(m.id); if (narrow) setPanel(false); }} style={{ padding: '10px 4px', borderBottom: `1px solid ${T.line}`, fontSize: 14, cursor: 'pointer', wordBreak: 'break-word' }}>
                    {m.webpage?.title && <div style={{ fontWeight: 600, marginBottom: 2 }}>{m.webpage.title}</div>}
                    <div style={{ color: '#d3dce5', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}><RichText text={m.text} entities={m.entities} /></div>
                  </div>
                ))}
              </div>
            )}
            {!panelLoading && panelTab === 'posts' && panelItems.length > 0 && (
              <div style={{ padding: 10, display: 'flex', flexDirection: 'column', gap: 8 }}>
                {panelItems.filter(m => !m.service).map(m => (
                  <div key={m.id} onClick={() => { jumpTo(m.id); if (narrow) setPanel(false); }} style={{ background: m.out ? T.out : T.in, borderRadius: 12, overflow: 'hidden', cursor: 'pointer' }}>
                    {VISUAL[m.mediaType] && (
                      <div style={{ position: 'relative', height: 170, background: '#0f1923' }}>
                        <Blur thumb={m.thumb} />
                        <img src={mUrl(sel.id, m.id, m.mediaType === 'photo' ? '&size=preview' : '&size=thumb')} alt="" loading="lazy" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
                      </div>
                    )}
                    <div style={{ padding: '8px 11px' }}>
                      {m.text ? <div style={{ fontSize: 14, lineHeight: 1.4, display: '-webkit-box', WebkitLineClamp: 5, WebkitBoxOrient: 'vertical', overflow: 'hidden', whiteSpace: 'pre-wrap' }}>{m.text}</div>
                        : <div style={{ fontSize: 14, color: T.sub }}>{mediaLabel(m.mediaType) || 'Mesaj'}</div>}
                      <div style={{ fontSize: 12, color: m.out ? T.metaOut : T.metaIn, marginTop: 4, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>{m.views > 0 && <span>👁 {fmtCount(m.views)}</span>}<span>{listTime(m.date)} {fmtTime(m.date)}</span></div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* ═════════ OVERLAYS ═════════ */}
      {ctxMenu && (
        <div onMouseDown={() => setCtxMenu(null)} onContextMenu={e => { e.preventDefault(); setCtxMenu(null); }} style={{ position: 'fixed', inset: 0, zIndex: 6500 }}>
          <div className="tgc-fade" onMouseDown={e => e.stopPropagation()} style={{ position: 'fixed', left: ctxMenu.x, top: ctxMenu.y, background: T.menu, borderRadius: 10, padding: 6, minWidth: 210, boxShadow: '0 8px 30px rgba(0,0,0,.55)' }}>
            {(() => {
              const list = ctxMenu.list;
              const m = list[list.length - 1];
              const realIds = list.every(x => typeof x.id === 'number');
              const items = [];
              if (m._failed) items.push({ i: 'trash', l: 'Kaldır', f: () => setMsgs(p => p.filter(x => x.id !== m.id)) });
              if (realIds) {
                items.push({ i: 'reply', l: 'Yanıtla', f: () => startReply(list[0]) });
                if (m.out && list.length === 1 && (m.text || !m.mediaType) && !m.fwdFrom) items.push({ i: 'edit', l: 'Düzenle', f: () => startEdit(m) });
                if (list.some(x => x.text)) items.push({ i: 'copy', l: 'Metni kopyala', f: () => copyText(list) });
                items.push({ i: 'pin', l: list[0].pinned ? 'Sabitlemeyi kaldır' : 'Sabitle', f: () => togglePinMsg(list[0]) });
                items.push({ i: 'forward', l: 'İlet', f: () => setFwd({ msgs: list }) });
                if (list.length === 1 && m.mediaType && !['poll', 'location', 'contact', 'webpage', 'dice'].includes(m.mediaType))
                  items.push({ i: 'download', l: 'Kaydet', f: () => { const a = document.createElement('a'); a.href = mUrl(sel.id, m.id, '&dl=1&name=' + encodeURIComponent(m.fileName || `telegram_${m.id}.${m.mediaType === 'photo' ? 'jpg' : m.mediaType === 'voice' ? 'ogg' : 'mp4'}`)); a.click(); } });
                items.push({ i: 'select', l: 'Seç', f: () => list.forEach(x => toggleSelect(x.id, true)) });
                items.push({ i: 'trash', l: 'Sil', f: () => askDelete(list), danger: true });
              }
              return items.map((it, k) => (
                <button key={k} className={'tgc-mi' + (it.danger ? ' danger' : '')} onClick={() => { setCtxMenu(null); it.f(); }}>
                  <Ic n={it.i} s={20} c={it.danger ? T.danger : T.dim} />{it.l}
                </button>
              ));
            })()}
          </div>
        </div>
      )}

      {viewer && <MediaViewer state={viewer} onClose={() => setViewer(null)} onNav={i => setViewer(v => (v ? { ...v, index: Math.max(0, Math.min(v.items.length - 1, i)) } : v))} />}

      {pendingFile && (
        <Modal onClose={closePending} w={420} pad={18}>
          <div style={{ fontSize: 17, fontWeight: 600, marginBottom: 14 }}>{pendingFile.kind === 'image' ? 'Fotoğraf gönder' : pendingFile.kind === 'video' ? 'Video gönder' : 'Dosya gönder'}</div>
          {pendingFile.kind === 'image' && <img src={pendingFile.url} alt="" style={{ width: '100%', maxHeight: 340, objectFit: 'contain', borderRadius: 8, background: '#0f1923', display: 'block' }} />}
          {pendingFile.kind === 'video' && <video src={pendingFile.url} controls style={{ width: '100%', maxHeight: 340, borderRadius: 8, background: '#000', display: 'block' }} />}
          {pendingFile.kind === 'file' && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ width: 52, height: 52, borderRadius: '50%', background: T.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}><Ic n="file" s={24} /></div>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{pendingFile.file.name}</div>
                <div style={{ fontSize: 13, color: T.sub }}>{fmtSize(pendingFile.file.size)}</div>
              </div>
            </div>
          )}
          <input autoFocus value={pendingFile.caption || ''} onChange={e => setPendingFile(p => ({ ...p, caption: e.target.value }))} onKeyDown={e => { if (e.key === 'Enter') sendPending(); }}
            placeholder="Açıklama ekleyin…" style={{ width: '100%', marginTop: 14, background: 'none', border: 'none', borderBottom: `2px solid ${T.accent}`, outline: 'none', color: T.text, fontSize: 15, padding: '8px 2px', fontFamily: 'inherit' }} />
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 6, marginTop: 14 }}>
            <TextBtn onClick={closePending}>İptal</TextBtn>
            <TextBtn onClick={sendPending} disabled={sending}>Gönder</TextBtn>
          </div>
        </Modal>
      )}

      {fwd && (
        <Modal onClose={() => { setFwd(null); setFwdQ(''); }} w={400} pad={0}>
          <div style={{ padding: '18px 18px 10px' }}>
            <div style={{ fontSize: 17, fontWeight: 600, marginBottom: 12 }}>İlet…</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: T.input, borderRadius: 20, padding: '0 12px', height: 38 }}>
              <Ic n="search" s={17} c={T.dim} />
              <input autoFocus value={fwdQ} onChange={e => setFwdQ(e.target.value)} placeholder="Ara" style={{ flex: 1, background: 'none', border: 'none', outline: 'none', color: T.text, fontSize: 14, fontFamily: 'inherit' }} />
            </div>
          </div>
          <div style={{ maxHeight: 400, overflowY: 'auto', padding: '0 6px 8px' }}>
            {dls.filter(d => !fwdQ || (d.name || '').toLocaleLowerCase('tr').includes(fwdQ.toLocaleLowerCase('tr'))).map(d => (
              <div key={d.id} className="tgc-row" onClick={() => doForward(d.id)} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '7px 10px', borderRadius: 10, cursor: 'pointer' }}>
                <Avatar id={d.id} name={d.name} size={44} />
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.name}</div>
                  <div style={{ fontSize: 13, color: T.sub }}>{d.isUser ? (d.bot ? 'bot' : 'kişi') : d.isGroup ? 'grup' : 'kanal'}</div>
                </div>
              </div>
            ))}
          </div>
        </Modal>
      )}

      {confirm && (
        <Modal onClose={() => setConfirm(null)} w={360}>
          <div style={{ fontSize: 17, fontWeight: 600, marginBottom: 8 }}>{confirm.title}</div>
          <div style={{ fontSize: 14.5, color: '#c7d1db', lineHeight: 1.5 }}>{confirm.text}</div>
          {confirm.check && (
            <div onClick={() => setConfirm(c => ({ ...c, check: { ...c.check, value: !c.check.value } }))}
              style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 16, cursor: 'pointer', userSelect: 'none' }}>
              <span style={{ width: 20, height: 20, borderRadius: 4, border: `2px solid ${confirm.check.value ? T.accent : '#6c7883'}`, background: confirm.check.value ? T.accent : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', flexShrink: 0, transition: 'all .12s' }}>
                {confirm.check.value && <Ic n="check" s={14} sw={3} />}
              </span>
              <span style={{ fontSize: 14.5 }}>{confirm.check.label}</span>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 6, marginTop: 18 }}>
            <TextBtn onClick={() => setConfirm(null)}>İptal</TextBtn>
            <TextBtn danger onClick={() => { const f = confirm.onOk; const v = confirm.check ? confirm.check.value : undefined; setConfirm(null); f(v); }}>{confirm.ok || 'Tamam'}</TextBtn>
          </div>
        </Modal>
      )}

      {senderProfile && (
        <Modal onClose={() => setSenderProfile(null)} w={320}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <Avatar id={senderProfile.id} name={senderProfile.name} size={96} />
            <div style={{ fontSize: 18, fontWeight: 600, marginTop: 12 }}>{senderProfile.name || 'Kullanıcı'}</div>
            <div style={{ fontSize: 13.5, color: T.sub, marginTop: 2, marginBottom: 14 }}>{sel?.name ? sel.name + ' üyesi' : 'Grup üyesi'}</div>
          </div>
          <button className="tgc-mi" onClick={() => {
            const id = senderProfile.id;
            const ex = dls.find(d => d.id === id);
            setSenderProfile(null);
            if (ex) openChat(ex);
            else { const d = { id, name: senderProfile.name || '?', isUser: !String(id).startsWith('-'), isGroup: false, isChannel: String(id).startsWith('-100'), unreadCount: 0, lastMsgText: '', lastMsgDate: null, lastMsgOut: false }; setDls(p => [d, ...p]); openChat(d); }
          }}><Ic n="send" s={20} c={T.link} />Mesaj gönder</button>
          <button className="tgc-mi" onClick={() => { const q = senderProfile.name; setSenderProfile(null); setChatSearch({ q: '', res: [], loading: false }); setTimeout(() => onChatSearch(q || ''), 0); }}><Ic n="search" s={20} c={T.dim} />Mesajlarını ara</button>
        </Modal>
      )}

      {meModal && (
        <Modal onClose={() => { setMeModal(false); setMeEd(false); }} w={380}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 16 }}>
            <Avatar id={me?.id} name={meName || '?'} size={96} />
            <div style={{ fontSize: 19, fontWeight: 600, marginTop: 12 }}>{meName}</div>
            <div style={{ fontSize: 14, color: T.link, marginTop: 2 }}>{me?.username ? '@' + me.username : ''}</div>
            {me?.phone && <div style={{ fontSize: 13.5, color: T.sub, marginTop: 2 }}>+{String(me.phone).replace(/^\+/, '')}</div>}
          </div>
          {!meEd ? (
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 6 }}>
              <TextBtn onClick={() => setMeModal(false)}>Kapat</TextBtn>
              <TextBtn onClick={() => setMeEd(true)}>Düzenle</TextBtn>
            </div>
          ) : (
            <form onSubmit={async e => {
              e.preventDefault();
              try { await api.put('/tg-client/me', meForm); setMe(p => ({ ...p, ...meForm })); setMeEd(false); setToast('Profil güncellendi'); }
              catch (ex) { setToast('Hata: ' + ex.message); }
            }}>
              {[['firstName', 'Ad'], ['lastName', 'Soyad'], ['bio', 'Hakkında']].map(([k, l]) => (
                <div key={k} style={{ marginBottom: 12 }}>
                  <div style={{ fontSize: 13, color: T.link, marginBottom: 2 }}>{l}</div>
                  <input value={meForm[k] || ''} onChange={e => setMeForm(p => ({ ...p, [k]: e.target.value }))}
                    style={{ width: '100%', background: 'none', border: 'none', borderBottom: `2px solid ${T.input}`, outline: 'none', color: T.text, fontSize: 15, padding: '6px 2px', fontFamily: 'inherit' }}
                    onFocus={e => { e.target.style.borderBottomColor = T.accent; }} onBlur={e => { e.target.style.borderBottomColor = T.input; }} />
                </div>
              ))}
              <label style={{ display: 'flex', alignItems: 'center', gap: 10, color: T.link, fontSize: 14, cursor: 'pointer', margin: '4px 0 10px' }}>
                <Ic n="photo" s={20} />Profil fotoğrafını değiştir
                <input type="file" accept="image/*" style={{ display: 'none' }} onChange={async ev => {
                  const f = ev.target.files?.[0]; if (!f) return;
                  const fd = new FormData(); fd.append('photo', f);
                  try { await api.post('/tg-client/me/photo', fd); _noPhoto.delete(String(me?.id)); setToast('Fotoğraf güncellendi'); } catch (ex) { setToast('Hata: ' + ex.message); }
                }} />
              </label>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 6 }}>
                <TextBtn onClick={e => { e.preventDefault(); setMeEd(false); }}>İptal</TextBtn>
                <button type="submit" style={{ background: 'none', border: 'none', color: T.link, fontWeight: 600, fontSize: 14, padding: '9px 14px', cursor: 'pointer', textTransform: 'uppercase', letterSpacing: .3, fontFamily: 'inherit' }}>Kaydet</button>
              </div>
            </form>
          )}
        </Modal>
      )}

      {toast && (
        <div className="tgc-fade" style={{ position: 'absolute', left: '50%', bottom: 86, transform: 'translateX(-50%)', background: 'rgba(0,0,0,.78)', color: '#fff', padding: '9px 16px', borderRadius: 10, fontSize: 14, zIndex: 9500, pointerEvents: 'none', maxWidth: '80%', textAlign: 'center' }}>{toast}</div>
      )}
    </div>
  );
}

function InfoRow({ icon, value, label, onCopy, multiline }) {
  return (
    <div className="tgc-row" onClick={onCopy} style={{ display: 'flex', gap: 22, padding: '10px 16px', borderRadius: 10, cursor: onCopy ? 'pointer' : 'default', alignItems: 'flex-start' }}>
      <Ic n={icon} s={22} c={T.dim} style={{ marginTop: 2 }} />
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 15, whiteSpace: multiline ? 'pre-wrap' : 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', wordBreak: 'break-word' }}>{multiline ? <RichText text={value} entities={null} /> : value}</div>
        <div style={{ fontSize: 13, color: T.sub, marginTop: 1 }}>{label}</div>
      </div>
    </div>
  );
}
